{
  "InteractiveBookOptionalFilters": "يمكن تصفية الوحدات حسب الشهادة والدورة اختيارياً، أو البحث مباشرة باسم الوحدة أو ترتيبها.",
  "InteractiveBookCertificateFilter": "الشهادة (اختياري)",
  "InteractiveBookCourseFilter": "الدورة (اختياري)",
  "InteractiveBookLinkedUnit": "وحدة نظام التعلم المرتبطة",
  "InteractiveBookLinkedTopic": "موضوع نظام التعلم المرتبط",
  "InteractiveBookSearchNameRank": "ابحث بالاسم أو الترتيب",
  "InteractiveBookLinkParentFirst": "اختر وحدة نظام التعلم المرتبطة بالفصل واحفظها قبل ربط موضوعاته.",
  "InteractiveBookUnitRequired": "اختر وحدة صالحة من نظام التعلم لهذا الفصل.",
  "InteractiveBookTopicRequired": "اختر موضوعاً تابعاً لوحدة نظام التعلم المرتبطة بالفصل.",
  "InteractiveBookUnitChangeConfirmation": "سيؤدي تغيير وحدة الفصل إلى إزالة روابط الموضوعات من أقسامه مع الاحتفاظ بمحتواها. هل تريد المتابعة ثم اختيار موضوعات جديدة؟",
  "InteractiveBookLinkLoadError": "تعذر تحميل خيارات نظام التعلم. غيّر البحث لإعادة المحاولة.",
  "InteractiveBookRefineSearch": "تظهر أول 100 نتيجة. حدد البحث للوصول إلى نتائج أدق.",
  "translations": {
    "PackageProperties": "خصائص الباقات",
    "PackageProperty": "الخاصية",
    "PackagePropertyValue": "القيمة",
    "PackagePropertiesApiUnavailable": "تعذر تحميل خصائص الباقات. تأكد من تثبيت تحديث خصائص الباقات وترحيل قاعدة البيانات على الخادم المتصل، ثم أعد المحاولة.",
    "PackagePropertiesRetry": "إعادة المحاولة",
    "PackagePropertyTypeBOOLEAN": "نعم / لا",
    "PackagePropertyTypeNUMBER": "رقم",
    "PackagePropertyTypeTEXT": "نص",
    "PackagePropertyTypeLocked": "لا يمكن تغيير نوع خاصية مستخدمة في الباقات. أزل ارتباطاتها قبل تغيير نوعها أو حذفها، أو ألغِ تفعيلها لإخفائها عن الطلاب.",
    "PackagePropertyDuplicate": "هذه الخاصية محددة بالفعل لهذه الباقة.",
    "ComparePackages": "مقارنة الباقات",
    "SelectPackageToCompare": "مقارنة {{name}}",
    "BookDocumentJson": "حزمة كتاب تفاعلي (.json)",
    "BookDocumentWord": "استيراد مستند Word (.docx)",
    "BookDocumentPdf": "استيراد مستند PDF (.pdf)",
    "BookDocumentDraftHint": "راجع التحويل قبل إنشاء مسودة غير منشورة. أكمل التحرير وربط المقررات في محرر الكتاب.",
    "BookDocumentFile": "المستند المصدر",
    "BookDocumentWordLimit": "ملفات DOCX فقط، حتى 25 ميغابايت. احفظ ملفات .doc القديمة بصيغة .docx أولاً. قد يتغير تنسيق الصفحات.",
    "BookDocumentPdfLimit": "حتى 50 ميغابايت و150 صفحة مختارة. اترك نطاق الصفحات كما هو لاستيراد ملف PDF كاملاً.",
    "BookDocumentTitle": "عنوان الكتاب",
    "BookDocumentLanguage": "لغة المحتوى المستورد",
    "BookDocumentArabic": "العربية",
    "BookDocumentEnglish": "الإنكليزية",
    "BookDocumentSplit": "بنية الفصول والأقسام",
    "BookDocumentSplit_headings": "اقتراح فصول وأقسام حسب العناوين",
    "BookDocumentSplit_single": "فصل واحد وقسم واحد",
    "BookDocumentSplit_pages": "قسم لكل صفحة PDF",
    "BookDocumentFromPage": "الصفحة الأولى",
    "BookDocumentToPage": "الصفحة الأخيرة",
    "BookDocumentLastPage": "نهاية المستند",
    "BookDocumentMode": "طريقة تحويل PDF",
    "BookDocumentMode_text": "نص قابل للتحرير فقط",
    "BookDocumentMode_images": "صفحات PDF الأصلية (التنسيق والصور)",
    "BookDocumentModeHint_images": "استيراد صفحات PDF كاملة كصور عالية الدقة مع الحفاظ على الخطوط والألوان والصور والجداول والرسوم وتخطيط الصفحة. لا يمكن تحرير النصوص والعناصر داخل كل صفحة بشكل منفصل.",
    "BookDocumentModeHint_text": "استخراج نص وعناوين قابلة للتحرير دون التنسيق والصور وتخطيط الصفحة الأصلي. اختر صفحات PDF الأصلية للحفاظ على محتوى الصفحة كاملاً.",
    "BookDocumentAnalyzing": "تحليل المستند: {{completed}} / {{total}}",
    "BookDocumentAnalyze": "تحليل ومعاينة",
    "BookDocumentCover": "صورة الغلاف",
    "BookDocumentNoCover": "بدون غلاف",
    "BookDocumentImage": "صورة",
    "BookDocumentPage": "صفحة",
    "BookDocumentWarnings": "راجع تنبيهات التحويل",
    "BookDocumentPages": "صفحات المصدر وخيار حفظها كصور",
    "BookDocumentPreviewPage": "معاينة الصفحة",
    "BookDocumentPdfTags": "تعذّرت قراءة وسوم العناوين في PDF. تم الاحتفاظ بالنص المستخرج؛ راجع العناوين المقترحة.",
    "BookDocumentPdfWorkerError": "تعذّر بدء محوّل PDF أو توقف بشكل غير متوقع. أعد تحميل الصفحة ثم حاول مجدداً.",
    "BookDocumentErrorDetails": "تفاصيل الخطأ",
    "BookDocumentDiagnosticsHint": "انسخ هذا السجل، أو صفِّ وحدة تحكم المتصفح باستخدام [Book {{kind}} import].",
    "BookDocumentWordWorkerError": "تعذّر بدء محوّل Word أو توقف بشكل غير متوقع. أعد تحميل الصفحة ثم حاول مجدداً. توضح تفاصيل الخطأ موضع المشكلة.",
    "BookDocumentWordConversionError": "تعذّر تحويل مستند Word. افتح تفاصيل الخطأ لمعرفة المرحلة التي توقف عندها.",
    "BookDocumentStage_word_read": "قراءة ملف Word",
    "BookDocumentStage_word_worker": "بدء محوّل Word",
    "BookDocumentStage_word_archive": "التحقق من بنية مستند Word",
    "BookDocumentStage_word_convert": "تحويل النص والجداول والصور من Word",
    "BookDocumentStage_word_content": "تهيئة المحتوى لمحرر الكتاب",
    "BookDocumentStage_worker": "بدء محوّل PDF",
    "BookDocumentStage_open": "قراءة بنية PDF وعدد صفحاته",
    "BookDocumentStage_page": "تحميل صفحة المصدر",
    "BookDocumentStage_text": "استخراج النص القابل للتحرير",
    "BookDocumentStage_tags": "قراءة وسوم عناوين PDF",
    "BookDocumentStage_render": "إنشاء صورة الصفحة",
    "BookDocumentPageChangeHint": "تغيير طريقة استيراد صفحة يعيد إنشاء البنية المقترحة ويلغي تعديلات البنية اليدوية. اختر طريقة الصفحات قبل إعادة تسمية الأقسام أو ترتيبها.",
    "BookDocumentIncludeChapter": "تضمين الفصل",
    "BookDocumentIncludeSection": "تضمين القسم",
    "BookDocumentMoveUp": "نقل للأعلى",
    "BookDocumentMoveDown": "نقل للأسفل",
    "BookDocumentDemote": "دمج في الفصل السابق",
    "BookDocumentPromote": "إنشاء فصل جديد",
    "BookDocumentPreview": "معاينة",
    "BookDocumentMergeNext": "دمج القسم التالي",
    "BookDocumentBlocks": "تضمين المحتوى وتقسيم الأقسام",
    "BookDocumentSplitHere": "تقسيم قبل هذه الكتلة",
    "BookDocumentChooseSection": "اختر قسماً لمعاينة محتواه.",
    "BookDocumentSummary": "{{chapters}} فصول · {{sections}} أقسام · {{images}} صور · نحو {{megabytes}} ميغابايت",
    "BookDocumentAcknowledge": "راجعت التنبيهات والمحتوى المضمن في هذه المسودة.",
    "BookDocumentBack": "العودة إلى خيارات التحويل",
    "BookDocumentCreateDraft": "إنشاء مسودة غير منشورة",
    "BookDocumentInvalidFile": "اختر مستنداً صالحاً يطابق نوع الملف المحدد.",
    "BookDocumentLimit": "يتجاوز المستند حدود الاستيراد. اختر صفحات أقل أو مستنداً أصغر.",
    "BookDocumentUnsupportedWord": "صيغة Word غير مدعومة. احفظ ملف .docx عادياً دون وحدات ماكرو أو تشفير.",
    "BookDocumentTimeout": "استغرق التحويل وقتاً طويلاً. اختر صفحات أقل أو بسّط المستند ثم أعد المحاولة.",
    "BookDocumentEmpty": "لم يبق محتوى للاستيراد. ضمّن قسماً واحداً على الأقل يحتوي على محتوى.",
    "BookDocumentPageRange": "اختر نطاقاً صالحاً لا يتجاوز 150 صفحة ضمن هذا الملف.",
    "BookDocumentEncrypted": "ملفات PDF المحمية بكلمة مرور غير مدعومة. استورد نسخة غير محمية.",
    "BookDocumentTitleRequired": "يحتاج الكتاب وكل فصل وقسم مضمن إلى عنوان لا يتجاوز 255 حرفاً.",
    "BookDocumentInvalidContent": "بعض المحتوى المحول غير صالح. راجع المستند أو جرّب حفظ صفحات PDF كصور.",
    "BookDocumentExternalResources": "لم تُجلب المراجع الخارجية للمستند. راجع الصور والموارد المرتبطة.",
    "BookDocumentTrackedChanges": "يحتوي مستند Word على تغييرات متعقبة. أُبقيت الإضافات واستُبعدت الحذوفات؛ راجع النص الناتج.",
    "BookDocumentWordStories": "أُدرج نص وصور الترويسات والتذييلات مرة واحدة قرب قسمها الأصلي. قد يتغير تكرار الترويسات وموضع العلامة المائية والترقيم التلقائي للصفحات.",
    "BookDocumentWordStoryMissing": "تعذر العثور على ترويسة أو تذييل مشار إليه داخل مستند Word. راجع محتواه في المصدر.",
    "BookDocumentUnsupportedObjects": "قد تفقد المعادلات والرسومات والكائنات المضمنة تنسيقها أو محتواها. قارنها بالمستند الأصلي.",
    "BookDocumentUnsupportedImage": "تعذر استيراد صيغة إحدى الصور. أُبقي النص البديل عند توفره.",
    "BookDocumentSanitized": "أُزيلت عناصر HTML أو خصائص غير مدعومة من المستند المحول.",
    "BookDocumentUnsafeLink": "أُزيل رابط غير مدعوم أو غير آمن مع الإبقاء على نصه.",
    "BookDocumentNoteFormatting": "أُبقي النص المرتفع والمنخفض ومراجع الهوامش كنص عادي.",
    "BookDocumentTableFallback": "حُفظ جدول معقد كنص. راجع ترتيب خلاياه.",
    "BookDocumentConversionWarning": "تنبيه تحويل Word",
    "BookDocumentScannedPage": "لا تحتوي هذه الصفحة على طبقة نص قابلة للاستخدام وحُفظت كصورة.",
    "BookDocumentComplexPage": "قد تحتوي الصفحة على أعمدة أو مسافات غير معتادة. راجع ترتيب القراءة أو احفظها كصورة.",
    "BookDocumentMixedDirection": "تجمع الصفحة بين العربية والإنكليزية. قارن ترتيب الكلمات والحروف والأرقام بصورة الصفحة؛ احفظها كصورة إذا كان استخراج النص غير دقيق.",
    "BookDocumentPdfReview": "يقترح تحويل PDF نصاً وعناوين قابلة للتحرير. قارن الرسومات والجداول والترويسات المتكررة وترتيب القراءة العربي والإنكليزي بصور الصفحات الأصلية.",
    "BookDocumentSubmitError": "رفض الخادم الاستيراد. بقي الاقتراح متاحاً للتصحيح أو إعادة المحاولة.",
    "BookDocumentSubmitUnknown": "تعذر تأكيد نتيجة الاستيراد. تحقق من مكتبة الكتب قبل إعادة المحاولة لتجنب إنشاء نسخة مكررة.",
        "BookKnowledgeDescription": "اختبر مدى فهمك لهذا الموضوع.",
        "BookKnowledgeUnavailable": "لا توجد اختبارات معرفة متاحة لهذا الموضوع ضمن اشتراكك الحالي.",
        "BookKnowledgeQuestions": "{{count}} سؤال",
        "BookKnowledgeProgress": "تقدم الاختبار: {{percent}}٪",
        "BookKnowledgeLatestResult": "آخر نتيجة",
        "BookKnowledgeScore": "{{score}} / {{total}}",
        "BookKnowledgeNotTaken": "لم تكمل هذا الاختبار بعد.",
        "BookKnowledgeStart": "ابدأ اختبار معرفتك",
        "BookKnowledgeReview": "مراجعة المحاولة",
        "BookKnowledgeOpenError": "تعذر فتح الاختبار. يرجى المحاولة مجددًا.",
        "BookChapterTests": "اختبارات المعرفة: {{title}}",
        "BookAudio": "تسجيل صوتي",
        "BookAudioAdd": "إضافة تسجيل صوتي",
        "BookAudioEdit": "تعديل التسجيل الصوتي",
        "BookAudioTitle": "العنوان (اختياري)",
        "BookAudioDescription": "الوصف (اختياري)",
        "BookAudioRecord": "تسجيل الصوت",
        "BookAudioStopRecording": "إيقاف التسجيل",
        "BookAudioUpload": "رفع ملف صوتي",
        "BookAudioInsert": "استخدام هذا التسجيل",
        "BookAudioRequesting": "بانتظار السماح باستخدام الميكروفون…",
        "BookAudioPreparing": "جارٍ تجهيز التسجيل…",
        "BookAudioRecording": "جارٍ التسجيل",
        "BookAudioLimits": "MP3 أو WAV أو OGG أو WebM أو M4A بحجم أقصى 25 ميغابايت. التسجيل المباشر: حتى 10 دقائق.",
        "BookAudioSaveHint": "احفظ القسم لرفع الملف والاحتفاظ بالتسجيل الصوتي.",
        "BookAudioPlay": "تشغيل التسجيل الصوتي",
        "BookAudioPause": "إيقاف الصوت مؤقتًا",
        "BookAudioSeek": "موضع التشغيل",
        "BookAudioRestart": "التشغيل من البداية",
        "BookAudioForward": "التقديم 10 ثوانٍ",
        "BookAudioSpeed": "سرعة التشغيل: {{speed}}x",
        "BookAudioMute": "كتم الصوت",
        "BookAudioUnmute": "إلغاء كتم الصوت",
        "BookAudioPlayError": "تعذر تشغيل التسجيل. حاول مجددًا أو تحقق من الاتصال.",
        "BookAudioPermission": "لم يُسمح باستخدام الميكروفون. اسمح به من إعدادات المتصفح أو ارفع ملفًا صوتيًا.",
        "BookAudioUnsupported": "يتطلب التسجيل متصفحًا يدعمه واتصال HTTPS أو localhost. يمكنك رفع ملف صوتي بدلًا من ذلك.",
        "BookAudioRecordError": "تعذر التسجيل من الميكروفون. تحقق من الجهاز وحاول مجددًا.",
        "BookAudioInvalidType": "اختر ملفًا صوتيًا صالحًا بصيغة MP3 أو WAV أو OGG أو WebM أو M4A.",
        "BookAudioEmpty": "الملف الصوتي فارغ. أعد التسجيل أو اختر ملفًا آخر.",
        "BookAudioTooLarge": "يجب ألا يتجاوز حجم الملف الصوتي 25 ميغابايت.",
        "BookAudioTooMany": "يمكنك رفع حتى 10 ملفات صوتية عند حفظ القسم.",
        "BookAudioMappingInvalid": "يوجد ملف صوتي مفقود. اختره أو سجله مجددًا قبل الحفظ.",
        "BookMediaUploadError": "تعذر رفع الوسائط. تحقق من الملفات وحاول مجددًا.",
        "BookKnowledgeReadFirst": "أكمل قراءة جميع أقسام هذا الموضوع في الكتاب لفتح الاختبار.",
        "BookKnowledgeReadTopic": "قراءة الموضوع",
        "BookNoAccessibleSections": "لا توجد أقسام من الكتاب متاحة ضمن اشتراكك الحالي.",
        "BookRemoveCourseLink": "حذف ربط المقرر",
        "BookRemoveCourseConfirmation": "هل تريد حذف ربط المقرر؟ لن يتمكن الطلاب من الوصول إلى هذا الكتاب عبر هذا المقرر. سيتم الاحتفاظ بالتقدم والملاحظات المحفوظة.",
        "BookChangeCourseHint": "تغيير المقرر يمسح اختيارات الوحدات والمواضيع. حدد الربط للمقرر الجديد قبل الحفظ. تبقى سجلات الطلاب مرتبطة بالمقرر الأصلي.",
        "BookCourseRemoveError": "تعذر حذف ربط المقرر. يرجى المحاولة مجدداً.",
        "BookCourseLinkNotFound": "لم يعد ربط المقرر موجوداً. أعد تحميل الكتاب.",
    "BookAnnotationFilters": "الفلاتر",
    "BookFilterChapter": "الفصل",
    "BookFilterSection": "القسم",
    "BookFilterAllChapters": "جميع الفصول",
    "BookFilterAllSections": "جميع الأقسام",
    "BookFilterNoteType": "نوع الملاحظة / الوسم",
    "BookFilterAllTypes": "جميع الأنواع",
    "BookFilterTime": "آخر تعديل",
    "BookFilterTime_all": "كل الأوقات",
    "BookFilterTime_today": "اليوم",
    "BookFilterTime_week": "آخر 7 أيام",
    "BookFilterTime_month": "آخر 30 يوماً",
    "BookFilterTime_custom": "تاريخ ووقت مخصصان",
    "BookFilterFrom": "من",
    "BookFilterTo": "إلى",
    "BookFilterInvalidRange": "يجب أن تكون النهاية بعد البداية أو مساوية لها.",
    "BookFilterSort": "الترتيب حسب",
    "BookFilterSort_newest": "الأحدث أولاً",
    "BookFilterSort_oldest": "الأقدم أولاً",
    "BookFilterSort_chapter": "اسم الفصل",
    "BookFilterSort_section": "اسم القسم",
    "BookFilterSort_page": "ترتيب صفحات الكتاب",
    "BookFilterSort_color": "اللون",
    "BookFilterAllColors": "جميع الألوان",
    "BookFilterReset": "إعادة تعيين",
    "BookFilterApply": "تطبيق الفلتر",
    "BookFiltersNoResults": "لا توجد عناصر محفوظة تطابق البحث والفلاتر.",
    "BookAddBookmark": "إضافة إشارة مرجعية",
    "BookBookmarkCurrentSection": "القسم الحالي",
    "BookBookmarkAlreadySaved": "تم حفظ إشارة مرجعية للقسم الحالي",
    "BookBookmarksLoading": "جارٍ تحميل الإشارات المرجعية…",
    "BookBookmarksEmpty": "لا توجد إشارات مرجعية بعد. احفظ القسم الحالي للعودة إليه لاحقاً.",
    "BookBookmarksLoadError": "تعذّر تحميل الإشارات المرجعية. حاول مرة أخرى.",
    "BookBookmarksSaveError": "تعذّر حفظ تغييرات الإشارات المرجعية. حاول مرة أخرى.",
    "BookBookmarkUnavailable": "القسم غير متاح",
    "BookOpenBookmark": "فتح {{title}}، الصفحة {{page}}",
    "BookDeleteBookmark": "حذف الإشارة المرجعية: {{title}}",
    "BookRemoveHighlight": "إزالة التظليل",
    "EditorSpaceBefore": "المسافة أعلى الكتلة (بكسل)",
    "EditorSpaceAfter": "المسافة أسفل الكتلة (بكسل)",
    "EditorSpacingDefault": "افتراضي",
    "EditorTwoColumns": "عمودان",
    "EditorThreeColumns": "ثلاثة أعمدة",
    "EditorColumnSectionStyle": "قسم الأعمدة",
    "EditorColumnSectionBackground": "خلفية القسم",
    "EditorColumnSectionPadding": "المسافة الداخلية للقسم (بكسل)",
    "EditorColumnSectionRadius": "استدارة زوايا القسم (بكسل)",
    "EditorResetColumnSectionStyle": "إعادة ضبط تنسيق القسم",
    "EditorColumnStyle": "البطاقة المحددة",
    "EditorColumnCount": "عدد الأعمدة",
    "EditorColumnBackground": "خلفية البطاقة",
    "EditorColumnBorder": "لون إطار البطاقة",
    "EditorColumnBorderWidth": "سمك الإطار (بكسل)",
    "EditorColumnRadius": "استدارة الزوايا (بكسل)",
    "EditorColumnPadding": "المسافة الداخلية (بكسل)",
    "EditorResetColumnStyle": "إعادة ضبط تنسيق البطاقة",
    "EditorUnwrapColumns": "تحويل إلى كتل متتالية",
    "EditorColumnCountHint": "عند التغيير من ثلاثة أعمدة إلى عمودين، ينتقل محتوى البطاقة الثالثة إلى الثانية.",
    "EditorApplyColor": "تطبيق اللون",
    "EditorIncreaseIndent": "زيادة المسافة البادئة",
    "EditorDecreaseIndent": "تقليل المسافة البادئة",
    "BookAnnotationCopyError": "تعذر نسخ النص. يمكنك تحديده ونسخه يدوياً.",
    "BookSelectionActions": "النص المحدد",
    "BookHighlightAction": "تمييز",
    "BookNoteAction": "ملاحظة",
    "BookHighlightColor": "لون التظليل",
    "BookNoteColor": "لون الملاحظة",
    "BookSavedNotes": "الملاحظات المحفوظة",
    "BookSavedHighlights": "التظليلات المحفوظة",
    "BookNewNote": "إضافة ملاحظة جديدة",
    "BookEditNote": "تعديل الملاحظة",
    "BookEditHighlight": "تعديل التظليل",
    "BookNoteTitle": "العنوان",
    "BookNoteTitlePlaceholder": "أدخل عنوان الملاحظة…",
    "BookNoteText": "النص",
    "BookNoteTextPlaceholder": "اكتب ملاحظاتك هنا بالتفصيل…",
    "BookNoteTags": "التاغات",
    "BookAddTag": "+ إضافة تاغ",
    "BookSaveNote": "حفظ الملاحظة",
    "BookTagExam": "هام للامتحان",
    "BookTagSummary": "ملخص",
    "BookTagDefinition": "تعريف",
    "BookTagFormula": "صيغة",
    "BookTagExample": "مثال",
    "BookAnnotationCopy": "نسخ",
    "BookAnnotationCopied": "تم النسخ",
    "BookAnnotationOpen": "فتح القارئ",
    "BookAnnotationDeleteConfirm": "هل تريد حذف هذا العنصر المحفوظ؟",
    "BookAnnotationSaving": "جارٍ الحفظ…",
    "BookAnnotationsLoading": "جارٍ تحميل ملاحظاتك وتظليلاتك…",
    "BookAnnotationsEmpty": "لا توجد عناصر محفوظة. حدد نصاً في الكتاب لإضافة تظليل أو ملاحظة.",
    "BookAnnotationsSearch": "ابحث في العناصر المحفوظة…",
    "BookAnnotationsSelectHint": "حدد نصاً في الكتاب لتظليله أو إضافة ملاحظة.",
    "BookAnnotationsLoadError": "تعذر تحميل ملاحظاتك وتظليلاتك. حاول مجدداً.",
    "BookAnnotationsSaveError": "تعذر حفظ التغيير. ما زالت ملاحظتك هنا؛ حاول مجدداً.",
    "BookAnnotationInvalid": "تعذر حفظ العنصر. ربما تغير النص؛ أعد فتح الكتاب وحدد النص مجدداً.",
    "BookAnnotationColor0": "أصفر",
    "BookAnnotationColor1": "أخضر",
    "BookAnnotationColor2": "أزرق",
    "BookAnnotationColor3": "وردي",
    "BookAnnotationColor4": "بنفسجي",
    "BookAnnotationColor5": "برتقالي",
    "?": "؟",
    "InteractiveBook": "الكتاب",
    "BookContents": "محتويات الكتاب",
    "BookChapterCount": "عدد الفصول: {{count}}",
    "BookPageCount": "عدد الصفحات: {{count}}",
    "BookPagePosition": "صفحة {{current}} من {{total}}",
    "BookStudyTools": "أدوات الدراسة",
    "BookSearch": "البحث في الكتاب",
    "BookSearchPrompt": "البحث في صفحات الكتاب",
    "BookSearchPlaceholder": "ابحث عن كلمة أو مفهوم...",
    "BookSearchHint": "اكتب كلمة للبحث ضمن كامل صفحات الكتاب",
    "BookSearchResults": "الصفحات المطابقة: {{count}}",
    "BookSearchEmpty": "لم يتم العثور على صفحات مطابقة.",
    "BookSearchMore": "عرض المزيد من النتائج",
    "BookHighlights": "التظليلات",
    "BookNotes": "الملاحظات",
    "BookBookmarks": "الإشارات المرجعية",
    "BookAddHighlight": "إضافة تظليل",
    "BookAddNote": "إضافة ملاحظة",
    "BookAssistant": "مساعد الدراسة",
    "BookToolUnavailable": "غير متاح حالياً",
    "BookPagesOpened": "تم فتح {{opened}} من {{total}} صفحات",
    "BookToggleChapter": "فتح أو طي {{title}}",
    "BookExpandPages": "فتح الصفحات",
    "BookCollapsePages": "طي الصفحات",
    "BookVisitProgressHint": "الصفحات المفتوحة خلال هذه الزيارة",
    "ChapterReadingTimeMinutes": "وقت القراءة (بالدقائق)",
    "ChapterReadingTimeOptional": "اختياري — اتركه فارغاً للإخفاء",
    "ChapterReadingTime": "وقت القراءة: {{minutes}} دقيقة",
    "InteractiveBookReadingTimeInvalid": "أدخل عدداً صحيحاً من الدقائق بين 1 و65535، أو اترك الحقل فارغاً.",
    "InteractiveBookAdmin": "الكتاب التفاعلي",
    "InteractiveBookAdminDescription": "أنشئ كتباً تفاعلية متاحة لجميع الطلاب.",
    "NewInteractiveBook": "كتاب تفاعلي جديد",
    "InteractiveBookLibrary": "مكتبة الكتب التفاعلية",
    "Published": "منشور",
    "Draft": "مسودة",
    "CoverImageUrl": "رابط صورة الغلاف",
    "BookCoverImage": "صورة غلاف الكتاب",
    "BookChooseCoverImage": "اختيار صورة",
    "BookReplaceCoverImage": "استبدال الصورة",
    "BookRemoveCoverImage": "إزالة الصورة",
    "BookCoverImageHint": "JPEG أو PNG أو WebP أو GIF، بحد أقصى 15 ميجابايت.",
    "PublishedForStudents": "منشور للطلاب",
    "SelectOrCreateInteractiveBook": "اختر كتاباً أو أنشئ كتاباً جديداً.",
    "InteractiveBookLoadError": "تعذر تحميل الكتاب.",
    "InteractiveBookSaveError": "تعذر حفظ الكتاب.",
    "InteractiveBookDeleteError": "تعذر حذف الكتاب.",
    "InteractiveBookTitleRequired": "أضف عنواناً باللغة الإنجليزية أو العربية على الأقل.",
    "NoInteractiveBook": "لم يتم إنشاء كتب تفاعلية بعد.",
    "InteractiveBookStudentDescription": "استكشف الكتب والمواد التعليمية.",
    "NoPublishedInteractiveBook": "لا توجد كتب منشورة حتى الآن.",
    "Retry": "إعادة المحاولة",
    "BackToInteractiveBook": "العودة إلى الكتب",
    "EditorFormatting": "تنسيق النص",
    "EditorMoreTools": "المزيد من أدوات المحرر",
    "EditorBlockTools": "الكتل",
    "EditorMediaTools": "الوسائط",
    "EditorBlocks": "كتل المحتوى",
    "EditorAddBlock": "إضافة كتلة",
    "EditorCurrentBlock": "الكتلة الحالية",
    "EditorParagraph": "فقرة",
    "EditorHeading1": "عنوان 1",
    "EditorHeading2": "عنوان 2",
    "EditorHeading3": "عنوان 3",
    "EditorBold": "عريض",
    "EditorItalic": "مائل",
    "EditorUnderline": "تحته خط",
    "EditorStrike": "يتوسطه خط",
    "EditorHighlight": "تمييز",
    "EditorInlineCode": "كود داخل النص",
    "EditorBulletList": "قائمة نقطية",
    "EditorOrderedList": "قائمة مرقمة",
    "EditorQuote": "اقتباس",
    "EditorQuoteColor": "لون الاقتباس",
    "EditorQuoteBackground": "خلفية الاقتباس",
    "EditorCodeBlock": "كتلة كود",
    "EditorDivider": "فاصل",
    "EditorHardBreak": "سطر جديد",
    "EditorAlignLeft": "محاذاة لليسار",
    "EditorAlignCenter": "توسيط",
    "EditorAlignRight": "محاذاة لليمين",
    "EditorJustify": "ضبط النص",
    "EditorLink": "إضافة أو تعديل رابط",
    "EditorRemoveLink": "إزالة الرابط",
    "EditorImage": "إدراج صورة عند المؤشر",
    "EditorImageFromUrl": "إدراج صورة من رابط",
    "EditorUploadImage": "رفع صورة من الجهاز",
    "EditorUploadImageBlock": "رفع كتلة صورة",
    "EditorAlignImageLeft": "محاذاة الصورة المحددة لليسار",
    "EditorAlignImageCenter": "توسيط الصورة المحددة",
    "EditorAlignImageRight": "محاذاة الصورة المحددة لليمين",
    "EditorFitImageWidth": "ملاءمة الصورة المحددة لعرض المحتوى",
    "EditorResetImageSize": "إعادة الصورة المحددة إلى حجمها الأصلي",
    "EditorTableTools": "أدوات الجدول",
    "EditorTable": "جدول",
    "EditorTableGeneral": "عام",
    "EditorTableStructure": "الأعمدة والصفوف والعناوين والخلايا",
    "EditorTableColumns": "الأعمدة",
    "EditorTableRows": "الصفوف",
    "EditorTableHeaders": "العناوين",
    "EditorTableCells": "الخلايا",
    "EditorTableAppearance": "مظهر الجدول بالكامل",
    "EditorTableRowAppearance": "مظهر الصف الحالي",
    "EditorTableCellAppearance": "مظهر الخلايا المحددة",
    "EditorInsertTable": "إدراج جدول 3 في 3",
    "EditorAddColumnBefore": "إضافة عمود قبل الحالي",
    "EditorAddColumnAfter": "إضافة عمود بعد الحالي",
    "EditorDeleteColumn": "حذف العمود الحالي",
    "EditorAddRowBefore": "إضافة صف قبل الحالي",
    "EditorAddRowAfter": "إضافة صف بعد الحالي",
    "EditorDeleteRow": "حذف الصف الحالي",
    "EditorToggleHeaderRow": "تبديل صف العناوين",
    "EditorToggleHeaderColumn": "تبديل عمود العناوين",
    "EditorToggleHeaderCell": "تبديل خلية العنوان المحددة",
    "EditorMergeCells": "دمج الخلايا المحددة",
    "EditorSplitCell": "تقسيم الخلية الحالية",
    "EditorTableBackground": "خلفية الجدول",
    "EditorClearTableBackground": "إعادة خلفية الجدول الافتراضية",
    "EditorTableRowBackground": "خلفية الصف الحالي",
    "EditorClearTableRowBackground": "استخدام خلفية الجدول لهذا الصف",
    "EditorTableCellBackground": "خلفية الخلية المحددة",
    "EditorClearTableCellBackground": "استخدام خلفية الجدول للخلايا المحددة",
    "EditorTableBorders": "حدود الجدول",
    "EditorHideTableBorders": "إخفاء الحدود",
    "EditorShowTableBorders": "إظهار الحدود",
    "EditorTableBorderColor": "لون حدود الجدول",
    "EditorTableBorderWidth": "سماكة حدود الجدول",
    "EditorTableBorderStyle": "نمط حدود الجدول",
    "EditorTableBorderReset": "إعادة حدود الجدول",
    "EditorRowBorderColor": "لون حدود الصف الحالي",
    "EditorRowBorderWidth": "سماكة حدود الصف الحالي",
    "EditorRowBorderStyle": "نمط حدود الصف الحالي",
    "EditorRowBorderReset": "استخدام حدود الجدول لهذا الصف",
    "EditorCellBorderColor": "لون حدود الخلايا المحددة",
    "EditorCellBorderWidth": "سماكة حدود الخلايا المحددة",
    "EditorCellBorderStyle": "نمط حدود الخلايا المحددة",
    "EditorCellBorderReset": "استخدام حدود الصف أو الجدول للخلايا المحددة",
    "EditorAlignTableLeft": "محاذاة الجدول إلى اليسار",
    "EditorAlignTableCenter": "محاذاة الجدول إلى الوسط",
    "EditorAlignTableRight": "محاذاة الجدول إلى اليمين",
    "EditorDeleteTable": "حذف الجدول",
    "EditorWatermarkTools": "أدوات العلامة المائية",
    "EditorWatermark": "علامة مائية",
    "EditorPageWatermarkTitle": "العلامة المائية لصفحة المحتوى",
    "EditorPageWatermarkText": "نص العلامة المائية للصفحة",
    "EditorPageWatermarkUpload": "رفع صورة علامة مائية للصفحة",
    "EditorPageWatermarkImage": "صورة العلامة المائية للصفحة",
    "EditorPageWatermarkRemoveImage": "إزالة صورة العلامة المائية للصفحة",
    "EditorPageWatermarkColor": "لون نص العلامة المائية للصفحة",
    "EditorPageWatermarkOpacity": "شفافية العلامة المائية للصفحة",
    "EditorPageWatermarkSize": "حجم العلامة المائية للصفحة",
    "EditorPageWatermarkRotation": "دوران العلامة المائية للصفحة",
    "EditorPageWatermarkClear": "مسح العلامة المائية للصفحة",
    "EditorSectionWatermarkTitle": "العلامة المائية لقسم البطاقتين/الثلاث بطاقات الحالي",
    "EditorSectionWatermarkText": "نص العلامة المائية للقسم",
    "EditorSectionWatermarkUpload": "رفع صورة علامة مائية للقسم",
    "EditorSectionWatermarkImage": "صورة العلامة المائية للقسم",
    "EditorSectionWatermarkRemoveImage": "إزالة صورة العلامة المائية للقسم",
    "EditorSectionWatermarkColor": "لون نص العلامة المائية للقسم",
    "EditorSectionWatermarkOpacity": "شفافية العلامة المائية للقسم",
    "EditorSectionWatermarkSize": "حجم العلامة المائية للقسم",
    "EditorSectionWatermarkRotation": "دوران العلامة المائية للقسم",
    "EditorSectionWatermarkClear": "استخدام العلامة المائية للصفحة في هذا القسم",
    "EditorWatermarkInherited": "يستخدم هذا القسم حالياً العلامة المائية للصفحة.",
    "EditorWatermarkSelectSection": "ضع المؤشر داخل قسم من بطاقتين أو ثلاث لإعطائه علامة مائية خاصة.",
    "EditorIconTools": "أدوات الأيقونات",
    "EditorIcons": "الأيقونات",
    "EditorChooseIcon": "اختر أيقونة",
    "EditorIconColor": "لون الأيقونة",
    "EditorIconSize": "حجم الأيقونة",
    "EditorInsertIcon": "إدراج أيقونة عند المؤشر",
    "EditorUpdateSelectedIcon": "تحديث الأيقونة المحددة",
    "EditorRemoveSelectedIcon": "حذف الأيقونة المحددة",
    "EditorApplyIconToBullet": "تطبيق شكل النقطة ولونها",
    "EditorRemoveCustomBullet": "إعادة شكل النقطة ولونها إلى الوضع الافتراضي",
    "EditorIconCheck": "علامة صح",
    "EditorIconCross": "علامة خطأ",
    "EditorIconInfo": "معلومة",
    "EditorIconWarning": "تحذير",
    "EditorIconLightbulb": "فكرة",
    "EditorIconBook": "كتاب",
    "EditorIconNote": "ملاحظة",
    "EditorIconStar": "نجمة",
    "EditorIconTarget": "هدف",
    "EditorIconFlag": "علم",
    "EditorIconQuestion": "سؤال",
    "EditorIconMessage": "رسالة",
    "EditorIconHeadphones": "سماعات",
    "EditorIconChart": "رسم بياني",
    "EditorIconShield": "درع",
    "EditorIconScales": "ميزان",
    "EditorPasteImageHint": "الصق صورة من الحافظة أو اسحب ملفات الصور وأفلتها هنا. يتم رفع الملفات عند حفظ القسم.",
    "InteractiveBookImageEmpty": "الصورة المحددة فارغة.",
    "InteractiveBookImageInvalidType": "استخدم صورة بصيغة JPEG أو PNG أو WebP أو GIF.",
    "InteractiveBookImageTooLarge": "يجب ألا يتجاوز حجم كل صورة 15 ميجابايت.",
    "InteractiveBookTooManyImages": "يمكن رفع 20 صورة جديدة كحد أقصى في عملية حفظ واحدة للقسم.",
    "InteractiveBookImageMappingInvalid": "تعذر مطابقة صورة أو أكثر من الصور المعلقة مع محتوى القسم.",
    "InteractiveBookImageUploadError": "فشل رفع الصورة.",
    "EditorClearFormatting": "مسح التنسيق",
    "EditorSelectAll": "تحديد الكل",
    "EditorUndo": "تراجع",
    "EditorRedo": "إعادة",
    "EditorAddTextBlock": "إضافة كتلة نص",
    "EditorAddHeadingBlock": "إضافة كتلة عنوان",
    "EditorAddSubheadingBlock": "إضافة كتلة عنوان فرعي",
    "EditorAddListBlock": "إضافة كتلة قائمة",
    "EditorAddQuoteBlock": "إضافة كتلة اقتباس",
    "EditorAddCodeBlock": "إضافة كتلة كود",
    "EditorAddDividerBlock": "إضافة كتلة فاصل",
    "EditorAddImageBlock": "إضافة كتلة صورة",
    "EditorMoveBlockUp": "نقل الكتلة للأعلى",
    "EditorMoveBlockDown": "نقل الكتلة للأسفل",
    "EditorBlockMoveHandle": "اسحب لنقل الكتلة، أو استخدم مفاتيح الأسهم لنقلها لأعلى أو لأسفل",
    "EditorDuplicateBlock": "تكرار الكتلة",
    "EditorDeleteBlock": "حذف الكتلة",
    "EditorColor": "اللون",
    "EditorTextColor": "لون النص",
    "EditorFontSize": "حجم الخط",
    "EditorFontFamily": "نوع الخط",
    "EditorResetTextStyle": "إعادة تنسيق الخط",
    "ContentStructure": "هيكل المحتوى",
    "ContentNavigation": "التنقل في المحتوى",
    "LearningChapter": "فصل",
    "LearningUnit": "وحدة",
    "LearningSection": "قسم",
    "AddChapter": "إضافة فصل",
    "AddUnit": "إضافة وحدة",
    "AddSection": "إضافة قسم",
    "NoContentStructure": "لم تتم إضافة فصول بعد.",
    "SaveInteractiveBookBeforeStructure": "احفظ الكتاب أولاً، ثم أضف فصولاً مرتبطة بوحدات نظام التعلم وأقساماً مرتبطة بموضوعاتها.",
    "SelectStructureNode": "اختر فصلاً أو قسماً.",
    "SaveSelectedNode": "حفظ العنصر المحدد",
    "ConfirmDeleteLearningNode": "هل تريد حذف هذا العنصر وكل ما بداخله؟",
    "InteractiveBookStructureSaveError": "تعذر حفظ هيكل المحتوى.",
    "InteractiveBookNodeTitleRequired": "أضف عنواناً إنجليزياً أو عربياً لهذا العنصر على الأقل.",
    "NoSectionsAvailable": "لا توجد أقسام متاحة للقراءة بعد.",
    "AboutUsText": "ابدأ رحلتك نحو النجاح والحصول على الشهادات المهنية مع ليرنينغ-غو",
    "AboutUsText1": "شريكك الموثوق به في عالم شهادات المحاسبة والتدقيق والإدارة. يكرس فريق الخبراء لدينا والمدعوم بأحدث الموارد التعليمية كامل جهوده لمساعدتك على إتقان المفاهيم المعقدة واجتياز الاختبارات بسهولة. في ليرنينغ-غو نؤمن بالتعلم المركز البعيد عن التشتت، حيث لم يعد هناك حاجة للبحث عن مصدر آخر للمعلومة. طريقك إلى إتقان مهني يبدأ هنا معنا. ابدأ رحلة التعلم الخاصة بك اليوم.",
    "AboutUsText2": "ليرنينغ-غو .... المنصة التي تطمح اليها، في كل وقت، وفي كل مكان.",
    "ProgramsText": "نحن نتفهم أن التحضير للشهادة المهنية يتطلب استثماراً هائلاً للوقت والجهد. يتمتع فريقنا بالخبرة المناسبة للتأكد من اجتيازك الاختبارات من المرة الأولى. مع ليرنينغ-غو ، أنت تتطلع إلى حياتك المهنية ، حيث سيكون لديك الأدوات والموارد والدعم الذي تحتاجه لاجتياز اختبارات الشهادات المهنية.",
    "Programs": "البرامج",
    "BrowseCertifications": "استعراض الشهادات",
    "ProfessionalCertificates": "الشهادات المهنية",
    "OurDistinctiveness": "مميزاتنا",
    "SendEmail": "ارسل بريد الكتروني",
    "LearningTeam": "فريق ليرنينغ غو",
    "Policies": "السياسات",
    "ChooseCoursesText": "اختر من بين العديد من الكورسات والبرامج الاخرى والتي تلبي تطلعاتكم واحتياجاتكم من خلال فيديوهات مسجلة بطريقة تفاعلية وشيقة مع إضافة كورسات وبرامج جديدة ومتنوعة بشكل دوري.",
    "ChooseCoursesText2": "اختر العديد من البرامج والكورسات الأونلاين والتي تلبي احتياجاتكم وتطلعاتكم ويتم إضافة برامج ومواضيع جديدة بشكل دوري",
    "Language": "اللغة",
    "Arabic": "العربية",
    "English": "English",
    "Home": "الرئيسية",
    "ChooseCertificate": "اختر الشهادة المهنية",
    "ChooseTopic": "اختر موضوع",
    "ChooseTopics": "اختر بعض المواضيع",
    "ChooseCourse": "اختر كورس",
    "Certifications": "الشهادات المهنية",
    "Certification": "الشهادة المهنية",
    "Courses": "الكورسات",
    "Course": "الكورس",
    "OneDayCourses": "كورسات بيوم",
    "OneDayCourse": "كورس بيوم",
    "FeaturesWithUs": "مزايا الدراسة معنا",
    "InteractiveLearningPlatform": "منصة التعلم التفاعلي",
    "InteractiveLearningPlatformText": "منصة تعليمية مرنة وسهلة الاستخدام، ومصممة لجعل دراستك أكثر سهولة.",
    "ModernInnovativeExplanation": "شرح حديث ومبتكر",
    "ModernInnovativeExplanationText": "شروحاتنا تفاعلية وحديثة بطريقة مبتكرة مما يجعل فعل المواضيع أكثر امتاعاً.",
    "PassGuarantee": "ضمان النجاح",
    "PassGuaranteeText": "نعدكم بالحصول على تحديثات منتظمة ودعم مستمر لاجتياز الاختبارات الدولية من المرة الأولى.",
    "StudyPlanner": "مخطط الدراسة",
    "StudyPlannerText": "المنصة تحوي على أداة مرنة تمكنكم من تخطيط المذاكرة والدراسة بناءً على جدولك الزمني وأسلوب حياتك.",
    "LargeTestBank": "بنك اختبار كبير",
    "LargeTestBankText": "منصتنا تحتوي على مجموعة كبيرة من أسئلة الاختيار المتعدد والاسئلة والمقالية من الاختبارات السابقة ومصادر أخرى مصصمة لإعدادك لاجتيار الاختبارات الدولية من المرة الأولى.",
    "MockExamText": "امتحانات تجريبية تحاكي الاختبار الحقيقي من حيث الأسئلة والتوقيت والشكل. ولدينا المُدربين المناسبين لتقييم أدائك وارشادك خلال دراستك.",
    "EnrollNow": "اشترك الآن",
    "DontHaveAccount": "ليس لديك حساب ؟",
    "AlreadyHaveAccount": "لديك حساب مسبقا ؟",
    "Error": "خطأ",
    "ErrorName": "الأسماء يجب أن تحتوي أحرف فقط",
    "ErrorBody": "حدث خطأ ما, الرجاء المحاولة لاحقا.",
    "ErrorConn": "يوجد خطأ في الاتصال, الرجاء المحاولة لاحقا.",
    "ErrorUncaught": "عذرا, لا يمكن اكمال العملية, حاول مرة أخرى",
    "ErrorPassword": "يجب أن تكون كلمة المرور أكثر من 6 أحرف",
    "ErrorPasswordMax": "يجب أن تكون كلمة المرور أقل من 20 حرف",
    "ErrorEmailExist": "هذا البريد الالكتروني مستخدم من قبل",
    "ErrorNameExist": "الاسم العربي والأجنبي موجودين مسبقا , الرجاء تغير كللاهما.",
    "EmailError": "بريد الكتروني غير صحيح",
    "MobileError": "رقم موبايل غير صحيح",
    "FormulaErrorUnclosedParenthesis": "خطأ في الصيغة: قوس غير مغلق. متوقع {{count}} قوس إغلاق إضافي.",
    "CheckEmail": "لقد قمنا بإرسال الرمز إلى البريد الالكتروني. يرجى التأكد من وصول البريد الالكتروني إما في البريد الوارد أو الرسائل غير المرغوب فيها",
    "SigninFail": "البريد الالكتروني أو كلمة السر غير صحيحة",
    "InvalidActivationCode": "رمز التفعيل غير صحيح أو منتهي الصلاحية",
    "InvalidResetCode": "لقد انتهت صلاحية هذا الرابط الرجاء طلب رابط جديد",
    "NotFound": "لا يوجد.",
    "NoPrint": "لا يمكنك طباعة الصفحة",
    "Note": "ملاحظة",
    "Empty": "فارغ",
    "Robot": "إنه بوت",
    "ComingSoon": "قريباً",
    "Success": "نجاح",
    "Required": "مطلوب",
    "TooLarge": "حجم الملف كبير",
    "NotPic": "ليست صورة",
    "Monday": "الإثنين",
    "Tuesday": "الثلاثاء",
    "Wednesday": "الأربعاء",
    "Thursday": "الخميس",
    "Friday": "الجمعة",
    "Saturday": "السبت",
    "Sunday": "الأحد",
    "Days": "أيام",
    "Day": "يوم",
    "Hours": "ساعات",
    "Hour": "ساعة",
    "Minutes": "دقائق",
    "Minute": "دقيقة",
    "Min": "د",
    "Seconds": "ثواني",
    "Second": "ثانية",
    "Progress": "التقدم",
    "TimeSpent": "الوقت",
    "TimeSpentPerQuestion": "الوقت الوسطي المستغرق لكل سؤال",
    "From": "من",
    "To": "إلى",
    "OverallGrade": "الدرجة النهائية",
    "ClickToLoadQuestion": "افتح السؤال ليتم تحميل النتيجة",
    "Users": "المستخدمون",
    "User": "المستخدم",
    "Pharmacy": "صيدلية",
    "Accounts": "الحسابات",
    "Categories": "الأصناف",
    "Category": "الصنف",
    "Tags": "الوسوم",
    "Notifications": "إشعارات",
    "Validity": "مدة الصلاحية الاشتراك",
    "NormalNotification": "اشعار عادي",
    "ImportantNotification": "اشعار مهم",
    "Valid": "صالح",
    "Invalid": "غير صالح",
    "Duration": "الزمن",
    "Settings": "إعدادات",
    "ExamsSettings": "إعدادات الفحوص",
    "Dashboard": "لوحة التحكم",
    "General": "عام",
    "Gender": "الجنس",
    "HR": "موارد بشرية",
    "Finance": "مالية",
    "Show": "عرض",
    "ViewOnly": "للعرض فقط",
    "Exams": "الامتحانات",
    "Info": "معلومات",
    "Reviews": "آراء",
    "Review": "رأي",
    "ReviewAnswers": "مراجعة الإجابات",
    "UsersRating": "تقييم المستخدمين",
    "Stars": "النجوم",
    "Map": "خريطة",
    "Profile": "الملف الشخصي",
    "FirstName": "الاسم الأول",
    "LastName": "الاسم الأخير",
    "FullName": "الاسم كامل",
    "ShortName": "الاختصار",
    "Copon": "كود الخصم",
    "CoponDiscount": "حسم كود الخصم",
    "Total": "المجموع",
    "UsedTimes": "مرات الاستخدام",
    "Buy": "شراء",
    "Reports": "التقارير",
    "Report": "تقرير",
    "Payment": "دفعة",
    "PaymentMethod": "طريقة الدفع",
    "QTicketQatar": "كيو تيكت قطر",
    "QTicketUAE": "كيو تيكت الإمارات",
    "Fatora": "فاتورة",
    "InvalidPayment": "عملية الدفع غير صالحة أو غير متاحة.",
    "PaymentAlreadyCompleted": "تم إكمال عملية الدفع هذه مسبقًا.",
    "PaymentMethodNotSupported": "طريقة الدفع هذه غير مدعومة.",
    "PaymentGatewayNotConfigured": "طريقة الدفع المحددة غير مهيأة.",
    "PaymentGatewayRequestFailed": "تعذر بدء عملية الدفع. يرجى المحاولة مرة أخرى.",
    "PaymentVerificationFailed": "تعذر التحقق من عملية الدفع.",
    "Payments": "الدفعات",
    "PaymentsReport": "تقرير الدفعات",
    "ContentReports": "ابلاغات المحتوى",
    "ReportProblem": "ابلاغ عن مشكلة",
    "ThanksForReportingIssue": "شكرًا لك على الإبلاغ عن مشكلة ، سنتحقق منها",
    "PaymentValue": "قيمة الدفع",
    "PaymentDate": "تاريخ الدفع",
    "EnsuringPaymentMessage": "إن آلية الدفع أمنة وسيتم تشفير بياناتك بشكل سري",
    "AssignedTo": "مسند إلى",
    "Name": "الاسم",
    "ID": "معرف",
    "Mobile": "موبايل",
    "Code": "رمز الدولة",
    "Country": "الدولة",
    "IP": "الآي بي",
    "IpLogs": "سجل الآي بي",
    "SignInLogs": "سجلات الدخول",
    "IpsCount": "عدد الآيبيات",
    "UseIps": "استخدام الآي بي",
    "OS": "نظام التشغيل",
    "DevicesCount": "عدد الأجهزة",
    "DevicesMaxCount": "عدد الأجهزة الأعظمي",
    "Latitude": "خط عرض",
    "Longitude": "خط طول",
    "ContinentName": "اسم القارة",
    "CountryName": "اسم الدولة",
    "RegionName": "اسم المنطقة",
    "City": "المدينة",
    "CreatedAt": "التاريخ",
    "Date": "التاريخ",
    "Active": "نشط",
    "Inactive": "غير نشط",
    "Blocked": "محظور",
    "Block": "حظر",
    "Alive": "فعال",
    "BlockedAccountText": "لقد تم إقفال الحساب، لمخالفة سياسات الموقع والاشتراك، يرجى التواصل مع فريق الدعم لحل المشكلة ولمزيد من المعلومات",
    "Correct": "صحيح",
    "Visible": "ظاهر",
    "Trial": "تجريبي",
    "Email": "البريد الالكتروني",
    "Options": "الخيارات",
    "Option": "الخيار",
    "PleaseWait": "الرجاء الانتظار",
    "CorrectOptionRequired": "الرجاء تحديد خيار صحيح",
    "Photo": "الصورة",
    "Attachments": "مرفقات",
    "Attachment": "مرفق",
    "StartAt": "يبدأ بـ",
    "EndAt": "ينتهي بـ",
    "Type": "النوع",
    "ExamType": "نوع الفحص",
    "QuestionsType": "نوع الأسئلة",
    "CorrectionDetails": "تفاصيل التصحيح",
    "ExamCorrection": "تصحيح الامتحان",
    "Corrected": "مصحح",
    "Theme": "الثيم",
    "QuestionsCount": "عدد الأسئلة",
    "TotalDegree": "الدرجة الكاملة",
    "Degree": "الدرجة",
    "SuccessRatio": "نسبة النجاح",
    "SuccessDegree": "درجة النجاح",
    "Distribution": "التوزيع",
    "DistributionNotValid": "توزيع الأسئلة غير صحيح",
    "DistributionFillAllQuestionCount": "لا يزال لدي بعض الأسئلة الحتمية و عدد الأسئلة العشوائية أقل منها",
    "DistributionRule1": "يمكن الاختيار على مستوى الوحدة أو الموضوع",
    "DistributionRule2": "الأسئلة الحتمية تساوي عدد أسئلة الامتحان",
    "DistributionRule3": "تعبر الأسئلة الحتمية عن وجود السؤال بالفحص بشكل أكيد",
    "DistributionRule4": "مثال عن الأسئلة العشوائية: في القسم المقالي من السوكبا يوجد سؤالين حتميات الورود و12 سؤال عشوائي من أصل 6 أسئلة كلية ,بالتالي يتم اختيار الأسئلة الحتمية الأربعة عشوائيا من ال 12",
    "DistributionRule5": "للتعبير عن منع السؤال من الظهور بالفحص بشكل أكيد نترك الخانة فارغة",
    "RandomQuestions": "أسئلة عشوائية",
    "Random": "عشوائي",
    "Mandatory": "حتمي",
    "RemainingMandatoryQuestions": "الأسئلة الحتمية المتبقية",
    "EnterUnitRatio": "أدخل عدد الأسئلة لهذه الوحدة",
    "EnterTopicRatio": "أدخل عدد الأسئلة لهذا الموضوع",
    "IncrementalTime": "وقت متزايد",
    "Features": "الميزات",
    "Feature": "ميزة",
    "PasswordMustMatch": "غير متطابق",
    "Owner": "المالك",
    "Address": "العنوان",
    "roleId": "الدور",
    "Order": "الترتيب",
    "SocialMedia": "التواصل الاجتماعي",
    "ArabicName": "الاسم العربي",
    "EnglishName": "الاسم الأجنبي",
    "ArabicDescription": "الوصف العربي",
    "EnglishDescription": "الوصف الأجنبي",
    "EnglishText": "النص الأجنبي",
    "ArabicText": "النص العربي",
    "EnglishAnswer": "الإجابة الأجنبية",
    "ArabicAnswer": "الإجابة العربية",
    "EnglishTitle": "العنوان الإنكليزي",
    "ArabicTitle": "العنوان العربي",
    "EnglishColumnName": "اسم العمود الأجنبي",
    "ArabicColumnName": "اسم العمود العربي",
    "EnglishExplanation": "شرح الإجابة الأجنبي",
    "ArabicExplanation": "شرح الإجابة العربي",
    "EnglishStructure": "الهيكل بالأجنبي",
    "EnglishFeatures": "الميزات بالأجنبي",
    "EnglishPromise": "الوعد بالأجنبي",
    "ArabicStructure": "الهيكل بالعربي",
    "ArabicFeatures": "الميزات بالعربي",
    "ArabicPromise": "الوعد بالعربي",
    "BioEn": "السيرة الأجنبية",
    "BioAr": "السيرة العربية",
    "SpecialtyEn": "التخصص بالأجنبي",
    "SpecialtyAr": "التخصص بالعربي",
    "KeyWords": "الكلمات المفتاحية",
    "Columns": "الأعمدة",
    "Column": "العمود",
    "Answers": "الأجوبة",
    "Answer": "الجواب",
    "Rank": "المرتبة",
    "Price": "السعر",
    "Cost": "الكلفة",
    "Discount": "الحسم",
    "John": "محمد",
    "Doe": "خالد",
    "New": "جديد",
    "Accepted": "تم القبول",
    "Accept": "قبول",
    "Rejected": "تم الرفض",
    "Reject": "رفض",
    "Pending": "قيد الانتظار",
    "Cancel": "الغاء",
    "Exit": "خروج",
    "OK": "موافق",
    "Add": "إضافة",
    "Save": "حفظ",
    "Reset": "تجاهل التغيرات",
    "Delete": "حذف",
    "ADD": "اضافة",
    "EDIT": "تعديل",
    "Edit": "تعديل",
    "Read": "قراءة",
    "READ": "قراءة",
    "Export": "تصدير",
    "EXPORT": "تصدير",
    "Send": "ارسال",
    "Next": "التالي",
    "Previous": "السابق",
    "Start": "إبدأ",
    "Done": "تم",
    "Generate": "توليد",
    "Join": "انضم",
    "Create": "إنشاء",
    "Confirm": "تأكيد",
    "RemoveAll": "حذف الكل",
    "Views": "مشاهدات",
    "Likes": "إعجاب",
    "Dislikes": "عدم إعجاب",
    "Viewers": "مشاهدين",
    "LookingFor": "البحث عن؟",
    "Back": "السابق",
    "BackToHome": "العودة للرئيسية",
    "Search": "بحث",
    "Choose": "اختر",
    "Logout": "خروج",
    "SelectAll": "تحديد الكل",
    "DeselectAll": "الغاء تحديد الكل",
    "Max": "الحد الأقصى",
    "Activate": "تفعيل",
    "WriteWisly": "اكتب بدقة",
    "Security": "الأمان",
    "Comments": "تعليقات",
    "Comment": "التعليق",
    "ViewMoreComments": "عرض المزيد من التعليقات...",
    "Rate": "تقييم",
    "CommentHere": "علق هنا...",
    "GeneralComment": "التعليق العام",
    "CorrectorComment": "تعليق المصحح",
    "StudentAnswer": "جواب الطالب",
    "TimeAndDate": "التاريخ والوقت",
    "SortBy": "ترتيب حسب",
    "Location": "الموقع الجغرافي",
    "Status": "الحالة",
    "Title": "العنوان",
    "Anonymous": "شخص مجهول",
    "InActiveAccount": "هذا الحساب معطل, الرجاء التواصل مع الإدارة لإعادة تفعيله",
    "Saved": "تم الحفظ",
    "Added": "تمت الإضافة",
    "Deleted": "تم الحذف",
    "Actions": "اجراءات",
    "Action": "اجراء",
    "Performance": "الأداء",
    "Sec": "ثانية",
    "Essay": "الاسئلة المقالية",
    "MCQS": "أسئلة الاختيار المتعدد",
    "Text": "نصي",
    "Tbs": "أسئلة المهام",
    "File": "ملف",
    "Files": "ملفات",
    "FileBank": "بنك أسئلة الملفات",
    "TbsBank": "بنك أسئلة المهام",
    "McqsBank": "بنك الأسئلة الاختيارية",
    "EssaysBank": "بنك الأسئلة المقالية",
    "TestKnowledge": "اختبار المعرفة",
    "MockExam": "الامتحان التجريبي",
    "Subscriptions": "الاشتراكات",
    "Subscription": "اشتراك",
    "Subscribers": "المشتركون",
    "Subscriber": "مشترك",
    "SubscriptionPackage": "باقة الاشتراك",
    "SubscriptionType": "نوع الاشتراك",
    "SubscriptionCost": "كلفة الاشتراك",
    "Paid": "مدفوع",
    "Visitor": "زائر",
    "Visitors": "الزوار",
    "Students": "الطلاب",
    "Student": "طالب",
    "Promotions": "الحسومات",
    "Promotion": "حسم",
    "Permissions": "الصلاحيات",
    "Permission": "صلاحية",
    "NotAllowed": "غير مسموح لك الدخول إلى هذه الصفحة",
    "Admins": "المدراء",
    "Admin": "مدير",
    "Units": "الوحدات",
    "Unit": "وحدة",
    "Topic": "موضوع",
    "Topics": "المواضيع",
    "Questions": "الأسئلة",
    "Question": "سؤال",
    "Size": "قياس",
    "Sizes": "القياسات",
    "Difficulty": "الصعوبة",
    "Difficulties": "الصعوبات",
    "Book": "مستند",
    "Books": "الكتب",
    "Video": "فيديو",
    "Videos": "فيديوهات",
    "Images": "الصور",
    "Image": "صورة",
    "Lives": "عروض مباشرة",
    "TopTenVideos": "أكثر 10 أفلام مشاهدة",
    "Uploads": "التحميلات",
    "Loading": "جار التحميل",
    "Subject": "الموضوع",
    "Preview": "معاينة",
    "Message": "الرسالة",
    "Messages": "رسائل",
    "Package": "باقة",
    "Packages": "الباقات",
    "CertificationsPackages": "باقات الشهادات المهنية",
    "CoursesPackages": "باقات الكورسات",
    "UnitsPackages": "باقات الوحدات",
    "CoursesSubscriptions": "اشتراكات الكورسات",
    "UnitsSubscriptions": "اشتراكات الوحدات",
    "Onetime": "لمرة واحدة",
    "Period": "فترة زمنية",
    "Description": "الوصف",
    "Instructor": "المدرب",
    "Instructors": "المدربون",
    "FullReviewSystem": "نظام مراجعة كاملة",
    "TestBankMockExams": "أسئلة البنك واختبارات تجريبية",
    "MockExams": "اختبارات تجريبية",
    "MockAndBankExams": "اختبار تجريبي وبنك",
    "BankExams": "فحوص بنك",
    "FrequentlyExams": "فحوص دورية",
    "BankAndFreqExams": "اختبار دوري وبنك",
    "FreqAndMockExams": "اختبار دوري وتجريبي",
    "BankAndFreqAndMockExams": "اختبار دوري وتجريبي وبنك",
    "UsedFor": "يستعمل لـ",
    "StudentDiscountsAvailable": "حسم للطلاب",
    "HighQualityTestBank": "بنك اختبار عالي الجودة وأسئلة مقالية ، بما في ذلك شرح بالفيديو",
    "RealisticExam": "تجربة واقعية ليوم الامتحان",
    "FullSupportAssistance": "المساعدة والدعم الكامل",
    "DigitalMaterialSlides": "مواد رقمية و عروض تقدمية",
    "VideoLecturesSeries": "سلسة محاضرات فيديوية",
    "OnlineStudyPlanner": "مخطط الدارسة عبر الانترنت",
    "PersonalMentoring": "التوجيه الشخصي من قبل المحاسب الإداري محمد",
    "SuccessStories": "قصص نجاح",
    "NewsInfo": "معلومات الخبر",
    "CertificateInfo": "معلومات الشهادة المدنية",
    "UserInfo": "معلومات المستخدم",
    "AdminInfo": "معلومات المدير",
    "CourseInfo": "معلومات البرنامج",
    "UnitInfo": "معلومات الوحدة",
    "TopicInfo": "معلومات الموضوع",
    "OneDayCourseInfo": "معلومات كورس بيوم",
    "SizeInfo": "معلومات القياس",
    "DifficultyInfo": "معلومات الصعوبة",
    "CategoryInfo": "معلومات الصنف",
    "PromotionInfo": "معلومات الحسم",
    "ProblemInfo": "معلومات المسألة",
    "QuestionInfo": "معلومات السؤال",
    "OptionInfo": "معلومات الخيار",
    "RoleInfo": "معلومات الدور",
    "PackageInfo": "معلومات الباقة",
    "SubscriptionInfo": "معلومات الاشتراك",
    "InstructorInfo": "معلومات المدرب",
    "SuccessStoryInfo": "معلومات قصة النجاح",
    "CalendarInfo": "معلومات التقويم",
    "Calendar": "التقويم",
    "CoursesCalendar": "تقويم البرامج",
    "AddNewResource": "إضافة مورد جديد",
    "Role": "الدور",
    "Roles": "الأدوار",
    "Resource": "المورد",
    "Resources": "الموارد",
    "Explanations": "التفسير",
    "Explanation": "شرح الإجابة",
    "Format": "الصيغة",
    "Solved": "محلولة",
    "Remaining": "متبقية",
    "Flagged": "معلّمة",
    "Flag": "إشارة",
    "Finish": "إنهاء",
    "FinishSection": "إنهاء القسم",
    "QuestionsNumber": "عدد الأسئلة",
    "ChangeNumberQuestions": "تغير عدد الأسئلة",
    "ChooseOrderQuestions": "اختر ترتيب للأسئلة",
    "StartExam": "إبدأ امتحانك",
    "Decline": "رفض",
    "ChangeNumberQuestionsText": "أدخل عدد الأسئلة التي تريد مراجعتها",
    "ChooseOrderQuestionsText": "في أي ترتيب يجب أن يعرض النظام الأسئلة",
    "InStandardOrder": "بترتيب قياسي",
    "InRandomOrder": "بترتيب عشوائي",
    "SelectCourse": "اختر كورس لدراسته",
    "SelectUnit": "اختر وحدة",
    "NoExplanation": "جواب غير صحيح",
    "YourAnswer": "جوابك",
    "YouDidNotAnswer": "لم تجب على هذا السؤال",
    "ShowProblem": "عرض المسألة",
    "PleaseSelectCourseToStudy": "الرجاء تحديد الكورس أولاً من لوحة التحكم الخاصة بك",
    "NoQuestions": "لم يتم تضمين هذا الاختبار في هذا الكورس بعد",
    "YES": "نعم",
    "NO": "لا",
    "ExamNotAllowed": "عذرا, لست مشترك بحزمة تسمح لك بتقديم هذا الامتحان",
    "NoExam": "لم يتم تضمين هذا الاختبار في هذا الكورس بعد",
    "Watch": "شاهد",
    "Open": "فتح",
    "News": "الأخبار",
    "Announcements": "اعلانات",
    "IntroductoryVideo": "فيديو تعريفي عن المنصة",
    "IntroductoryVideoText": "شاهد الفيديو التعريفي التالي عن آلية عمل المنصة وكيف يمكن التنقل بين الخيارات والصفحات",
    "Other": "أُخرى",
    "OtherCourses": "كورسات أُخرى",
    "OurAchievements": "ما حققناه حتى الآن",
    "AlreadySubscribed": "أنت مشترك مسبقا في هذه الباقة",
    "AlreadySubscribedButNotPaid": "أنت مشترك مسبقا في هذه الباقة لكنك لم تدفع الاشتراك,اذهب لصحفة الاشتراكات واضغط زر الدفع",
    "YourExamWillStart": "أسئلة الموضوع على وشك البدء، هل انت مستعد؟",
    "YourExamHasFinished": "لقد انتهى اختبارك, شكراً لك",
    "YourViewHasFinished": "لقد انتهى استعراض الامتحان, شكرا لك",
    "ExamResults": "نتائج الاختبار",
    "Result": "النتيجة",
    "ResultAnalysis": "تحليل النتيجة",
    "PassingScore": "علامة النجاح هي",
    "Passed": "ناجح",
    "Failed": "غير ناجح",
    "BadUnitResult": "تحتاج إلى تحسين ملحوظ في هذا الجزء ",
    "MidUnitResult": "تحتاج إلى بعض التحسين في هذا الجزء",
    "GoodUnitResult": "أنت ممتاز في هذا الجزء",
    "CorrectAnswers": "أجوبة صحيحة",
    "CorrectAnswer": "جواب صحيح",
    "WrongAnswers": "أجوبة خاطئة",
    "WrongAnswer": "جواب خاطئ",
    "NotAnswered": "أسئلة غير محلولة",
    "NotAnsweredQuestion": "سؤال غير محلول",
    "Answered": "محلول",
    "FlaggedQuestions": "أسئلة معلّمة",
    "RetryWrong": "إعادة الفحص بالأسئلة الخاطئة",
    "RetryFlagged": "إعادة الفحص بالأسئلة المعلمة",
    "RetryNotAnswered": "إعادة الفحص بالأسئلة الغير محلولة",
    "MoveToEssaySection": "الانتقال للقسم المقالي",
    "MoveToEssaySectionText1": "لقد قمت بالانتهاء من جزء أسئلة الخيار المتعدد.",
    "MoveToEssaySectionText2": "هل تود الاستمرار والانتقال الى جزء الأسئلة المقالية أوالعودة لاحقاً لاستكمال الاختبار.",
    "MoveToNextSectionText1": "لقد قمت بالانتهاء من هذا القسم",
    "MoveToNextSectionText2": "هل تود الاستمرار والانتقال الى الجزء التالي أو العودة لاحقاً لاستكمال الاختبار",
    "MoveToNextSectionText3": "الرجاء إضغط استمرار للانتقال للقسم التالي, في حال خرجت من الامتحان لا يمكنك العودة إليه لاحقا",
    "StopBackLater": "التوقف والعودة لاحقاً",
    "ContinueMoveEssay": "الاستمرار – الانتقال الى جزء الأسئلة المقالية",
    "ContinueMove": "الاستمرار - الانتقال الى الجزء التالي",
    "SubmitTestLet": "انهاء القسم",
    "TestLet": "الاختبار {{letNumber}}",
    "AUDITINGANDATTESTATION": "التدقيق والتصديق",
    "AreYouReadyForExam": "هل أنت مستعد لتبدأ الامتحان؟",
    "AreYouSureFinishExam": "هل أنت متأكد أنك تريد انهاء الامتحان؟",
    "AreYouSureFinishSectionExam": "هل أنت متأكد أنك تريد الذهاب إلى قسم المقالات؟ بمجرد أن تذهب إلى قسم المقالات ، لا يمكنك العودة إلى هذا القسم",
    "AreYouSure?": "هل أنت متأكد؟",
    "MockExamFinishText1": "يرجى أخذ العلم بأننا سنقوم بإرسال بريد الكتروني إليك بتقرير نتائج الامتحان التجريبي قريباً بعد تصحيح الإجابات",
    "MockExamFinishText2": "يرجى التحقق من بريدك الإلكتروني والعودة إلينا إذا كان لديك أي أسئلة",
    "MockNot50Text": "أنت لم تجب على نصف أسئلة القسم الأول بشكل صحيح",
    "MockNotAnswerRequiredToMoveText": "أنت لم تجب على عدد كافي من أسئلة هذا القسم للانتقال للقسم التالي",
    "MockPageWarning": "إذا لم تحقق نسبة إنجاز في الأداء تتجاوز الـ 85%، فلن تكون مؤهلاً للاستفادة من ”وعد“ ليرنينغ-غو.",
    "MockPageListText1": "يحتوي هذا القسم على اختبارين تجريبيين.",
    "MockPageListText2": "نوصيك بإكمال الاختبار التجريبي 1 قبل أسبوعين تقريبًا من الاختبار الحقيقي.",
    "MockPageListText3": "نوصيك بإكمال الاختبار التجريبي 2 قبل أسبوع واحد تقريبًا من الاختبار الحقيقي.",
    "MockPageListText4": "الامتحانات التجريبية هي اختبارات شاملة وتتضمن أسئلة جديدة مصممة لمساعدتك في تحديد نقاط الضعف.",
    "MockPageListText5": "بعد الانتهاء من الاختبارات التجريبية، نوصيك بمراجعة ملخص تقرير الاختبار ثم عزز  نقاط الضعف من خلال مراجعة المحاضرات وحل المزيد من أسئلة الاختيار المتعدد والاسئلة المقالية.",
    "MockExam1": "الامتحان التجريبي 1",
    "MockExam2": "الامتحان التجريبي 2",
    "Recommendations": "توصيات",
    "Warning": "تحذير",
    "AlreadyOnGoingExam": "لديك امتحان سابق , هل تريد الاستمرار أم لا؟",
    "PolicyAgreement": "السياسة واتفاقيات الخصوصية",
    "PolicyAgreementText": "أقر بموجب هذه الشهادة بأنني لن أفشي محتوى هذا الاختبار، ولن أزيل أي مواد أو ملاحظات أو مواد أخرى غير مصرح بها من غرفة الاختبار. أفهم أن عدم الامتثال لمتطلبات هذه الشهادة قد يؤدي إلى إبطال درجاتي واستبعادي من الامتحانات المستقبلية. إن عدم الامتثال للبيان المذكور أعلاه سيعتبر انتهاكًا لبيان الممارسة المهنية الأخلاقية وقد يؤدي إلى إلغاء الشهادة.",
    "PolicyAgreementCIA": "اتفاقية عدم الكشف عن المعلومات السرية وشروط الاستخدام لاختبار التدقيق الداخلي المعتمد",
    "PolicyAgreementTextCIA": "أوافق على الالتزام والتقيد بقوانين منصة ليرنينغ غو بما في ذلك اتفاقية عدم الإفصاح وشروط الاستخدام العامة، وأدرك أن هذا الامتحان سري ومحمي بقانون حقوق النشر. <br/>لم أطلع على الأسئلة أو الأجوبة المباشرة التي قد تظهر في الامتحان، وأوافق على عدم مناقشة محتوى الامتحان مع أي فرد آخر. <br/>لن أسجل أو أنسخ أو أفصح أو أنشر أو أعيد إصدار أي أسئلة من الامتحان أو إجابات لها بشكل جزئي، أو كلي أو بأي طريقة أو بأي وسيلة قبل إجرائي للامتحان أو خلاله أو بعده سواء كان ذلك بطريقة شفوية أو كتابية أو عن طريق أي غرفة دردشة عبر الإنترنت  <br/>أو عن طريق أي لوحة إعلانية أو أي منتدى أو بأي رسالة نصية قصيرة أو بأي طريقة أخرى. لن يُسمح لك بالاستمرار إذا رفضت قبول هذه الشروط.",
    "PolicyAgreementTextCIAHeader": "قبول اتفاقية سرية المعلومات",
    "PolicyAgreementCIAAccept": "نعم، أقبل اتفاقية عدم الكشف عن المعلومات السرية وشروط الاستخدام لاختبار التدقيق الداخلي المعتمد",
    "PolicyAgreementCIADecline": "لا، أقبل اتفاقية عدم الكشف عن المعلومات السرية وشروط الاستخدام لاختبار التدقيق الداخلي المعتمد",
    "A": "أ",
    "B": "ب",
    "C": "جـ",
    "D": "د",
    "TermsAndConditions": "البنود و الشروط",
    "PrivacyPolicy": "سياسة الخصوصية",
    "ImportantLinks": "روابط هامة",
    "Link": "الرابط",
    "FollowUs": "تابعنا",
    "AllRightsReserved": "ليرنينغ-غو , جميع الحقوق محفوظة",
    "NA": "غير متوفر",
    "PrivacyPolicyIntroText": "تبني سياسة الخصوصية الخاصة بنا جنبًا إلى جنب مع كل من النشر وشروط الاستخدام الأساس الذي سيحدد علاقتك بنا والعكس صحيح. نحن ندرك أهمية تأمين بعض المعلومات الأساسية عند زيارة موقعنا على الإنترنت. يرجى قراءة ما يلي بعناية لضمان فهم شامل لآرائنا وممارساتنا فيما يتعلق بأية معلوماتك الشخصية وأي معلومات تزودنا بها وكيف سنتعامل مع هذه المعلومات.",
    "PrivacyPolicyInfoCollecting": "المعلومات التي نجمعها منك ونعالجها",
    "PrivacyPolicyInfoCollectingText1": "قد تكون البيانات التالية مطلوبة منك لتزويدك بالتفويض الذي سيمكنك من الوصول إلى ميزات معينة داخل موقعنا على الويب:",
    "PrivacyPolicyInfoCollectingList1Text1": "المعلومات التي تزودنا بها عند ملء حقولنا بجميع النماذج الموجودة في موقعنا. يتضمن ذلك المعلومات التي تقدمها عند التسجيل لاستخدام موقعنا الإلكتروني ، وعندما تشترك في خدماتنا ، وأحيانًا عندما تبلغ عن مشكلة باستخدام موقعنا.",
    "PrivacyPolicyInfoCollectingList1Text2": "قد نحتفظ أيضًا بسجلات لأي بريد إلكتروني أو هاتف أو منشور تستخدمه للاتصال بنا.",
    "PrivacyPolicyInfoCollectingList1Text3": "نقوم بتضمين الاستبيانات داخل موقعنا والتي قد تطلب معلومات معينة منك ، على الرغم من أن المشاركة في استطلاعاتنا اختيارية تمامًا.",
    "PrivacyPolicyInfoCollectingText2": "التفاصيل التالية التي نجمعها من زياراتك لموقعنا:",
    "PrivacyPolicyInfoCollectingList2Text1": "بيانات حركة المرور",
    "PrivacyPolicyInfoCollectingList2Text2": "بيانات الموقع",
    "PrivacyPolicyInfoCollectingList2Text3": "مدونات الويب",
    "PrivacyPolicyInfoCollectingList2Text4": "نظام التشغيل",
    "PrivacyPolicyInfoCollectingList2Text5": "استخدام المتصفح",
    "PrivacyPolicyInfoCollectingList2Text6": "بيانات الاتصال الأخرى - سواء كانت ضرورية لأغراض الفوترة الخاصة بك أو غير ذلك والموارد التي تصل إليها.",
    "PrivacyPolicyIpAddress": "عنوان IP وملفات تعريف الارتباط",
    "PrivacyPolicyIpAddressText1": "قد نقوم بجمع المعلومات التالية حول جهاز الكمبيوتر الخاص بك:",
    "PrivacyPolicyIpAddressList1Text1": "عنوان IP",
    "PrivacyPolicyIpAddressList1Text2": "نظام التشغيل",
    "PrivacyPolicyIpAddressList1Text3": "نوع المتصفح",
    "PrivacyPolicyIpAddressText2": "لإدارة النظام ولإبلاغ معلنينا بالبيانات المتراكمة.",
    "PrivacyPolicyIpAddressText3": "سيتم جمع هذه المعلومات للأغراض الإحصائية فقط ولن تحاول بأي حال من الأحوال تحديد هوية الفرد.",
    "PrivacyPolicyIpAddressText4": "يمكن الحصول على المعلومات من خلال ملف تعريف الارتباط الذي سيتم تخزينه في القرص الصلب لجهاز الكمبيوتر الخاص بك. سيرسل هذا الملف معلومات معينة إلى محرك الأقراص الثابتة لديك لضمان تقديم خدمة أكثر تخصيصًا إلى:",
    "PrivacyPolicyIpAddressList2Text1": "تمكننا من توقع حجم جمهورنا ونمط استخدامه ؛",
    "PrivacyPolicyIpAddressList2Text2": "لجمع المعلومات المتعلقة بتفضيلاتك ، وبالتالي السماح لنا بتخصيص موقعنا وفقًا لاهتماماتك وتفضيلاتك ؛",
    "PrivacyPolicyIpAddressList2Text3": "لتسريع عمليات البحث الخاصة بك",
    "PrivacyPolicyIpAddressList2Text4": "وبالتالي يمكن لنظامنا التعرف عليك عند العودة إلى موقعنا على الإنترنت.",
    "PrivacyPolicyIpAddressText5": "إذا كنت لا ترغب في قبول ملفات تعريف الارتباط ، يمكنك تنشيط إعداد المتصفح المسؤول عن ملفات تعريف الارتباط. ما لم تكن نشطًا في هذا الاستعراض ، فسيقوم نظامنا بتحرير ملفات تعريف الارتباط على محرك الأقراص الثابتة عند تسجيل الدخول إلى موقعنا.",
    "PrivacyPolicyStorePersonalData": "أين نقوم بتخزين بياناتك الشخصية",
    "PrivacyPolicyStorePersonalDataText1": "سيتم تخزين جميع المعلومات المقدمة على أنظمتنا الآمنة. تقع على عاتقك مسؤولية الحفاظ على سرية أي كلمة مرور نقدمها لك (أو تختارها) لتمكين الوصول إلى ميزات معينة داخل موقعنا على الويب. نوصيك بعدم مشاركة كلمة مرور مع أي شخص لضمان أمان حسابك وبياناتك.",
    "PrivacyPolicyStorePersonalDataText2": "لدينا إجراءات وأنظمة أمان صارمة للحفاظ على أمان بياناتك بشكل أفضل ومنع الوصول غير المصرح به. ومع ذلك ، فإن الإنترنت ليس آمنًا تمامًا. لذا فإن أي معلومات تزودنا بها عبر الإنترنت ستكون على مسؤوليتك الخاصة.",
    "PrivacyPolicyWithInfo": "ماذا نفعل بمعلوماتك",
    "PrivacyPolicyWithInfoText1": "سيتم استخدام المعلومات التي نحتفظ بها عنك من أجل:",
    "PrivacyPolicyWithInfoList1Text1": "تأكد من تقديم المواد الخاصة بنا إليك بأفضل شكل ممكن لك ولجهاز الكمبيوتر الخاص بك ؛",
    "PrivacyPolicyWithInfoList1Text2": "لتزويدك بجميع المعلومات والخدمات ذات الصلة باهتماماتك أو طلباتك التي وافقت عليها ، نتصل بك لهذه الأغراض.",
    "PrivacyPolicyWithInfoList1Text3": "للقيام بواجباتنا فيما يتعلق بأي عقود بينك وبيننا.",
    "PrivacyPolicyWithInfoList1Text4": "حتى تتمكن من الاستفادة من ميزاتنا التفاعلية عندما تريد.",
    "PrivacyPolicyWithInfoList1Text5": "لتزويدك بإشعارات في حالة حدوث أي تغييرات.",
    "PrivacyPolicyDisclosure": "إفشاء المعلومات الخاصة بك",
    "PrivacyPolicyDisclosureText1": "قد يتم الكشف عن معلوماتك لأطراف ثالثة للأسباب التالية:",
    "PrivacyPolicyDisclosureList1Text1": "إذا كنا ملزمين بمشاركة مثل هذه البيانات للامتثال لمتطلبات قانونية معينة أو العملاء أو غيرهم.",
    "PrivacyPolicyDisclosureList1Text2": "لمنع الاحتيال ومخاطر الائتمان",
    "PrivacyPolicyDisclosureList1Text3": "إذا كنا نبيع أو نشتري أيًا من ممتلكاتك التجارية ، فقد نحتاج إلى الكشف عن معلوماتك للمشتري أو البائع لهذه العقارات.",
    "PrivacyPolicyYourRights": "حقوقك",
    "PrivacyPolicyYourRightsText1": "قد يحتوي موقعنا على روابط لمواقع أخرى أو لشركات شريكة. يرجى قراءة سياساتهم وشروطهم بعناية قبل النشر والمعلومات الشخصية لأننا لسنا مسؤولين عن هذه المواقع أو لوائحها.",
    "PrivacyPolicyYourRightsText2": "إذا كنا نعتزم الكشف عن معلوماتك الشخصية لأي طرف ثالث ، فسنبلغك عادة قبل أن نجمع أي معلومات. ستتمكن من منع مثل هذه المعالجة عن طريق تحديد مربعات معينة في النماذج أو الصفحات الخاصة بنا. يمكنك أيضًا الاتصال بنا عبر info@learning-go.com إذا كانت لديك أية استفسارات.",
    "PrivacyPolicyAccessInfo": "الوصول إلى المعلومات",
    "PrivacyPolicyAccessInfoText1": "لديك الحق في الوصول إلى معلوماتك وأي معلومات نحتفظ بها عنك.",
    "PrivacyPolicyChanges": "التغييرات في سياسة الخصوصية الخاصة بنا",
    "PrivacyPolicyChangesText1": "نوصيك بمراجعة سياساتنا من وقت لآخر للبقاء على اطلاع بأية تغييرات. قد نخطرك بأي تغييرات مهمة نجريها على هذه الصفحة.",
    "PrivacyPolicyContact": "اتصال",
    "PrivacyPolicyContactText1": "نرحب بالأسئلة والتعليقات والطلبات المتعلقة بسياسة الخصوصية هذه ويجب توجيهها إلى info@learning-go.com",
    "TermsOfUseText": "من خلال الاستمرار في استخدام موقعنا والتنقل فيه ، فإنك توافق على الامتثال لجميع لوائحنا التي تشكل معًا سياسة النشر وسياسة الخصوصية وشروط الاستخدام التالية. إذا كنت لا توافق على أي من الشروط المذكورة ، نوصيك بعدم الاستمرار في استخدام موقعنا. يشير مصطلح ”Learning-Go“ أو “نحن” إلى مالك هذا الموقع. تشير مصطلحات “أنت” إلى مستخدمي وقراء هذا الموقع. إذا كانت لديك أية مخاوف ، فلا تتردد في الاستفسار باستخدام العنوان التالي: info@learning-go.com",
    "TermsOfUseReliance": "الاعتماد على المعلومات المنشورة وإخلاء المسؤولية",
    "TermsOfUseRelianceText1": "يتم توفير أي محتوى أو مادة داخل موقعنا لأغراض عامة فقط. نحن لا نتحمل أي مسؤولية عن أي خسارة قد تأتي من الوصول إلى المعلومات الموجودة على هذا الموقع وإلى أقصى حد يسمح به القانون المعمول به ، نحن لسنا مسؤولين عن أي خسارة أو أضرار مباشرة أو غير مباشرة قد تنشأ عن استخدام موقعنا.",
    "TermsOfUseAccessing": "الوصول إلى موقعنا",
    "TermsOfUseAccessingText1": "يُسمح بالدخول إلى موقعنا الإلكتروني على أساس مؤقت ، ونحتفظ بالحق في سحب أو تعديل الخدمة التي نقدمها على موقعنا دون إشعار. لا نتحمل المسؤولية إذا كان موقعنا غير متاح لأي سبب من الأسباب في أي وقت أو لأي فترة.",
    "TermsOfUseIntellectual": "حقوق الملكية الفكرية",
    "TermsOfUseIntellectualText1": "تمتلك Learning-Go ملكية جميع المواد والمحتوى والمواد المنشورة داخل موقعنا على الويب. جميع الأعمال محفوظة ومحمية بموجب قوانين ومعاهدات حقوق النشر حول العالم.",
    "TermsOfUseIntellectualText2": "يمكن للمستخدمين طباعة نسخة واحدة وتنزيل مقتطفات من المحتوى الخاص بنا على أي من صفحاتنا للرجوع إليها شخصيًا. يمكنك أيضًا لفت انتباه الآخرين في مؤسستك إلى المواد الموجودة في موقعنا على الإنترنت.",
    "TermsOfUseIntellectualText3": "يجب عدم تعديل أي مادة تقوم بتنزيلها أو طباعتها من موقعنا ، ولا يجوز لك استخدام أي صور فوتوغرافية أو رسوم توضيحية أو صور أو رسومات أو مقاطع فيديو أو تسجيلات صوتية على هذا الموقع منفصلة عن النص المصاحب لها.",
    "TermsOfUseIntellectualText4": "بصفتنا مؤلفي المواد الموجودة في موقعنا ، يجب دائمًا الاعتراف بنا ، جنبًا إلى جنب مع أي مساهمين محددين. لا يمكنك استخدام أي مادة داخل موقعنا لأغراض تجارية أو دون إذن منا للقيام بذلك منا أو من المرخصين لدينا.",
    "TermsOfUseIntellectualText5": "سيؤدي أي خرق للوائح السابقة إلى منعك من مواصلة استخدام موقعنا على الويب ويجب عليك محو أو إرجاع أو إتلاف أي من المواد المنسوخة أو المستخدمة.",
    "TermsOfUseFrequentlyUpdate": "يتم تحديث موقعنا بشكل متكرر",
    "TermsOfUseFrequentlyUpdateText1": "هدفنا هو تحديث وتطبيق التغييرات على موقعنا في أي وقت وفي أي مكان نراه مناسبًا. هذا يعني أنه قد يتم تغيير بعض المحتوى في أي وقت قد نعلق خلاله الوصول إلى موقعنا ، أو نختار إغلاقه إلى أجل غير مسمى. قد تكون أي بيانات أو مواد موجودة في موقعنا الإلكتروني قديمة ، ونحن لسنا ملزمين بتحديث هذه المواد.",
    "TermsOfUseResponsibility": "مسؤوليتنا",
    "TermsOfUseResponsibilityText1": "أي مادة يتم تحميلها أو عرضها داخل موقعنا لا تحمل أي ضمانات أو ضمانات أو شروط فيما يتعلق بدقتها.",
    "TermsOfUseResponsibilityText2": "نحن ، جنبًا إلى جنب مع أي من الأطراف الثالثة المرتبطة بنا ، نستبعد ما يلي:",
    "TermsOfUseResponsibilityText3": "جميع الشروط والضمانات والبنود الأخرى التي قد تكون ضمنية بخلاف ذلك بموجب القانون الأساسي أو القانون العام أو قانون الإنصاف.",
    "TermsOfUseResponsibilityText4": "أي مسؤولية عن خسارة أو ضرر مباشر أو غير مباشر أو كبير يتكبده أي مستخدم فيما يتعلق بموقعنا أو فيما يتعلق باستخدام أو عدم القدرة على الاستخدام أو نتائج استخدام موقعنا الإلكتروني وأي مواقع مرتبطة به وأي محتوى تم تحميله أو المنشورة عليها ، بما في ذلك ، على سبيل المثال لا الحصر ، أي مساءلة عن:",
    "TermsOfUseResponsibilityList1Text1": "فقدان الدخل.",
    "TermsOfUseResponsibilityList1Text2": "خسارة العمل.",
    "TermsOfUseResponsibilityList1Text3": "خسارة الأرباح أو العقود.",
    "TermsOfUseResponsibilityList1Text4": "فقدان المدخرات المقدرة.",
    "TermsOfUseResponsibilityList1Text5": "فقدان البيانات.",
    "TermsOfUseResponsibilityList1Text6": "فقدان الشهرة.",
    "TermsOfUseResponsibilityList1Text7": "يضيع وقت الإدارة أو المكتب.",
    "TermsOfUseResponsibilityText5": "لأي خسارة أو ضرر قد يحدث سواء كان ناتجًا عن حادث أو خرق للعقد أو غير ذلك ، حتى لو كان متوقعًا ، بشرط ألا يؤدي هذا الشرط إلى إحباط المطالبات المتعلقة بفقدان أو تلف ممتلكاتك المادية أو أي مطالبات أخرى تتعلق بالخسارة المالية المباشرة التي لم يتم استبعادها من قبل أي من الفئات المذكورة أعلاه.",
    "TermsOfUseResponsibilityText6": "لا يؤثر هذا على مسؤوليتنا عن الإصابة الشخصية الناشئة عن إهمالنا ، ولا مسؤوليتنا عن التحريف الاحتيالي أو التحريف فيما يتعلق بمسألة أساسية ، ولا أي مسؤولية أخرى لا يمكن استبعادها أو تقييدها بموجب القانون المعمول به.",
    "TermsOfUseYourInformation": "معلومات عنك وعن زياراتك لموقعنا",
    "TermsOfUseYourInformationText1": "نقوم بمعالجة المعلومات الخاصة بك وفقًا لسياسة الخصوصية الخاصة بنا. وباستخدام موقعنا ، فإنك توافق على هذه المعالجة وتتعهد بأن جميع البيانات التي قدمتها أو قمت بتحميلها أو أي منها دقيقة ، ما لم تحصل على إذن منا للقيام بخلاف ذلك.",
    "TermsOfUseViruses": "الفيروسات والقرصنة والجرائم الأخرى",
    "TermsOfUseVirusesText1": "يؤدي إساءة استخدام موقعنا الإلكتروني عن قصد من خلال إدخال مواد ضارة أو ضارة تقنيًا مثل الفيروسات أو أحصنة طروادة أو الديدان أو القنابل المنطقية أو مواد مماثلة إلى إنهاء حقك في استخدام موقعنا على الفور.",
    "TermsOfUseVirusesText2": "ستؤدي محاولة الوصول غير المصرح به إلى موقعنا على الويب أو من خلال أي جهاز كمبيوتر أو جهاز أو قاعدة بيانات يتم تخزين موقعنا عليها أو الاتصال به إلى استبعادنا من استخدام موقعنا.",
    "TermsOfUseVirusesText3": "إن مهاجمة موقعنا على الإنترنت عن طريق هجوم رفض الخدمة أو هجوم رفض الخدمة الموزع سيكون له نتائج مماثلة للانتهاكات المذكورة أعلاه.",
    "TermsOfUseVirusesText4": "لن تتحمل Learning-Go المسؤولية عن أي خسارة أو ضرر قد ينشأ عن هجوم رفض الخدمة أو المواد الخبيثة أو الضارة من الناحية التكنولوجية التي قد تصيب أجهزة الكمبيوتر أو البرامج أو البيانات أو المواد الأخرى بسبب استخدامك لموقعنا. المواقع أو نتيجة تنزيل أي من المواد المتوفرة في موقعنا.",
    "TermsOfUseLinks": "روابط من موقعنا",
    "TermsOfUseLinksText1": "قد يحتوي موقعنا على روابط لمواقع أخرى. يتم توفير هذه الروابط لمعلوماتك والمرجعية فقط. نحن لا نملك ولا نتحمل أي مسؤولية من أي نوع تجاه أي من هذه المواقع المرتبطة. محتواها ملك خاص بهم ، وليس لدينا سيطرة على المواد المقدمة بداخلها. Learning-Go ليست مسؤولة عن أي خسارة أو ضرر قد ينشأ عن استخدامك لهذه المواقع. عند زيارة أي من هذه المواقع من خلال صفحاتنا ، ننصحك بقراءة سياساتها وشروط الاستخدام لضمان امتثالك وتحديد كيفية استخدام هذه المواقع لمعلوماتك.",
    "TermsOfUseJurisdiction": "الاختصاص والقانون الواجب التطبيق",
    "TermsOfUseJurisdictionText1": "تخضع شروط الاستخدام وأي نزاع أو مطالبة تنشأ عنها أو فيما يتعلق بها أو موضوعها أو تكوينها (بما في ذلك النزاعات أو المطالبات غير التعاقدية) للقانون المعمول به ويتم تفسيره وفقًا له.",
    "TermsOfUseVariations": "الاختلافات",
    "TermsOfUseVariationsText1": "قد نقوم بتحديث هذه الشروط في أي وقت ، لذا يرجى مراجعة هذه الصفحة من وقت لآخر للتأكد من أنك على دراية بجميع الشروط والأحكام الخاصة بنا. هذا لمنع أي سوء فهم أو خروج عن اللوائح الجديدة. قد يتم استبدال بعض الشروط الواردة في هذه السياسة بأحكام أخرى مذكورة في مكان آخر على هذا الموقع.",
    "TermsOfUseYourConcerns": "مخاوفك",
    "TermsOfUseYourConcernsText1": "إذا كانت لديك أية مخاوف بشأن المواد التي تظهر على موقعنا ، فيرجى الاتصال info@learning-go.com",
    "ThanksText": "شكرا لكم لزيارة موقعنا!",
    "OurCertificates": "شهاداتنا",
    "ExploreSuccessStory": "اكتشف قصص نجاحنا",
    "Submit": "تقديم",
    "Male": "ذكر",
    "Female": "أنثى",
    "EditProfile": "تعديل حسابي الشخصي",
    "AvailableCourses": "الكورسات المتاحة",
    "Support": "الدعم و الشكاوي",
    "UnitComplition": "إكمال الوحدة",
    "UseCopon": "استخدم كود الخصم",
    "NotificationsAppearHere": "ستظهر جميع اشعاراتك هنا",
    "SelectExamQuestions": "اختيار أسئلة الفحص",
    "NumberOfQuestionsAndSorting": "عدد الأسئلة و الفرز",
    "ExitExam": "انهاء الامتحان",
    "BackToExam": "العودة للامتحان",
    "Continue": "استمرار",
    "ManualPayments": "الدفعات اليدوية",
    "PaymentTime": "وقت الدفع",
    "PaymentInfo": "معلومات الدفع",
    "PayeeName": "مدفوع له",
    "ERR_SUBSCRIBE_PAYED": "الاشتراك مدفوع بشكل كامل",
    "HonorRoll": "قائمة الشرف",
    "UserPerformance": "أداء الطالب",
    "CopyCourse": "نسخ الكورس",
    "Clone": "نسخ",
    "Up": "فوق",
    "Down": "تحت",
    "ChangeImage": "تغيير الصورة",
    "DeleteImage": "حذف الصورة",
    "ExamName": "اسم الفحص",
    "AddNote": "اضافة ملاحظة",
    "InvalidArgument": "قيم خاطئة",
    "InvalidUserAccountActivationCode": "كود تفعل غير صحيح",
    "InvalidUserAccountResetPasswordCode": "رمز غير صحيح",
    "NotExistsUserEmail": "بريد الكتروني غير موجود",
    "DuplicateEmail": "موجود مسبقا",
    "InvalidEmail": "بريد الكتروني غير صحيح",
    "InvalidPassword": "كلمة مرور غير صحيحة",
    "InvalidFirstname": "اسم غير صحيح",
    "InvalidLastname": "كنية غير صحيح",
    "InvalidName": "اسم غير صحيح",
    "UnknownError": "خطأ غير معروف",
    "InactiveAccount": "حساب غير فعال",
    "BlockedAccount": "حساب محظور",
    "InvalidSubscriptionPackage": "باقة اشتراك غير صالحة",
    "Mock1LinkNotFound": "فحص تجريبي أول غير موجود",
    "Mock1NotFinished": "فحص تجريبي أول غير منتهي",
    "LastExamRoundNotFinished": "آخر دورة امنتحانية غير منتهية",
    "ExamAttemptsCountExceeded": "انتهت عدد محاولات الفحص التجريبي",
    "UserHasValidSubscriptionOnPackage": "لديك اشتراك مسبق فعال لهذه الباقة",
    "UserHasNotCompleteSubscriptionOnPackage": "لديك اشتراك غير مدفوع لهذه الباقة",
    "DuplicateCode": "الرمز مكرر",
    "NOT_ALLOWED_EXAM_TYPE": "نمط الامتحان غير مسموح",
    "CanNotDeleteUsedEntity": "لا يمكن حذف كيان مستخدم",
    "Composite": "الأسئلة المركبة",
    "FileQuestions": "اسئلة الملفات",
    "Section": "قسم",
    "DeleteAll": "حذف الكل",
    "TextSection": "قسم نصي",
    "SelectorSection": "قسم اختيار حقول",
    "ParagraphSection": "قسم مقال",
    "TableSection": "قسم جدول",
    "CheckBoxesSection": "قسم حقول الاختيار",
    "ChoicesManagement": "إدارة الخيارات",
    "CellsManagement": "إدارة خلايا الجدول",
    "TasksManagement": "إدارة المهام",
    "Content": "المحتوى",
    "AddNewSection": "إضافة قسم جديد",
    "GenerateTasks": "توليد المهام",
    "GenerateCells": "توليد الخلايا",
    "FieldsCount": "عدد الحقول",
    "RowsCount": "عدد الأسطر",
    "ColumnsCount": "عدد الأعمدة",
    "MultiChoiceQuestionOptions": "خيارات السؤال المتعدد",
    "InsertAnswerForTask": "أدخل أجوبة للمهمة {{task}}",
    "SelectorSectionHowToWork": "إذا أردت وضع جملة تحوي سؤال قم بوضع هذه الجملة ضمن الرمز @@{الجملة هنا} وبعد الانتهاء من كتابة النص كاملا قم بالنقر على توليد المهام لتبدأ عملية ادخال الخيارات",
    "ERR_CANNOT_ADD_NEWS_POPUP_WITH_CONFILCTING_DATES": "لا يمكن إضافة أكثر من إعلان من نوع Popup في تواريخ متداخلة",
    "DiscountType": "نوع الحسم",
    "Amount": "مبلغ",
    "Percent": "نسبة",
    "EnglishButtonText": "اسم الزر الأجنبي",
    "ArabicButtonText": "اسم الزر العربي",
    "RegStrategy": "طريقة الستجيل",
    "Translate": "ترجمة",
    "VideoInfoEdit": "تعديل معلومات الفديو",
    "REPLACE": "استبدال",
    "KEEP": "ابقاء",
    "DELETE": "حذف",
    "SerialNumber": "رقم تسلسلي",
    "SelectOptionBelow": "حدد خياراً أدناه",
    "FormattedResponse": "الجواب بالتنسيق",
    "PresentValueTable": "جدول القيم الحالية",
    "ColSpan": "امتداد العمود",
    "RowSpan": "امتداد السطر",
    "Introduction": "مقدمة",
    "DifrIntroText1": "يُظهر هذا الاختبار التجريبي كيفية تنظيم وتقييم الاختبار الفعلي، والتنسيق والأسلوب المتوقع للأسئلة، ونطاق خيارات الإجابة المتاحة لك في بيئة عمل كل سؤال.",
    "DifrIntroText2": "يُنصح بأداء هذا الاختبار التجريبي للتعرف على بيئة العمل والميزات والوظائف المضمنة في الاختبار الفعلي.",
    "DifrIntroText3": "يشبه هذا الاختبار التجريبي تجربة الاختبار الفعلي، ولكنه يتضمن بعض الاختلافات:",
    "DifrIntroText4": "في الاختبار الفعلي، سيتم تصحيح إجاباتك المُدخلة في بيئة العمل من قِبل خبير. أما في هذا الاختبار، فيجب عليك استخدام مواد الحل ذات الصلة.",
    "DifrIntroText5": "إذا كنت ترغب في أداء هذا الاختبار في ظروف مشابهة للاختبارات التقليدية، فيجب عليك الإجابة عن الأسئلة المقدمة ضمن المهلة الزمنية المحددة في الاختبار دون الرجوع إلى ملفات الحل مسبقًا.",
    "Navigator": "الموجه",
    "Requirements": "المتطلبات",
    "Exhibits": "المرافق",
    "ResponseOptions": "خيارات الإجابة",
    "WordProcessor": "معالج النصوص",
    "Spreadsheet": "جدول",
    "ScratchPad": "المسودة",
    "CloseAll": "إغلاق الكل",
    "Close": "اغلاق",
    "Marks": "علامة",
    "DuplicateRank": "هذا الترتيب موجود مسبقا",
    "Part": "قسم",
    "EditToSeeContent": "إضغط تعديل لمشاهدة المحتوى",
    "Chapters": "الفصول",
    "MockExamsManagement": "إدارة الامتحانات التجريبية",
    "ExamsManagement": "إدارة الامتحانات",
    "ParentExam": "الفحص الرئيسي",
    "ExamOrderBetweenTopics": "ترتيب الفحص بعد الموضوع ",
    "Demonstration": "التوضيح",
    "ExamInfo": "معلومات الفحص",
    "Inferential": "استنتاجي",
    "Analytical": "تحليلي",
    "Comprehensible": "فهمي",
    "FreqExam": "فحص دوري",
    "FreqParentExam": "فحص دوري رئيسي",
    "INVALID_EXAM_PARENT": "الفحص الرئيسي غير صحيح",
    "INVALID_EXAM_ORDER_NUM": "ترتيب الفحص غير صحيح",
    "TopicsAnalysis": "تحليل المواضيع",
    "AllQuestionHaveBeenCorrected": "تم تصحيح جميع الأسئلة",
    "StartCorrection": "إبدأ عملية التصحيح وتحليل النتيجة",
    "Main": "رئيسي",
    "YouHaveToAddMoreQuestions": "يجيب اضافة المزيد من الأسئلة",
    "EXCEED_ALLOWED_COUNT": "لا يمكنك تجاوز العدد الكلي للأسئلة",
    "StudentCanCorrect": "السماح للطالب بالتصحيح",
    "OnlyAdminCanCorrectThisQuestion": "تصحيح هذا السؤال مخصص للإدارة فقط",
    "ExamLinks": "روابط الامتحان",
    "ExpireAt": "ينتهي بـ",
    "Public": "عام",
    "Frequently": "دورية",
    "ResponseFiles": "ملفات الإجابة",
    "INVALID_PASS_LINK": "الرابط غير صحيح أو منتهي الصلاحية",
    "INVALID_USER": "المستخدم غير مسموح له",
    "Clear": "مسح",
    "AttemptsCount": "عدد المحاولات",
    "TryAgain": "حاول مجددا",
    "GoHome": "عودة للصحفة الرئيسية",
    "Blogs": "المقالات",
    "Events": "الفعاليات",
    "Event": "فعالية",
    "Blog": "مقال",
    "BlogInfo": "معلومات المقال",
    "Blogging": "المدونة",
    "AddNewBlock": "اضافة قسم جديد",
    "TextBlock": "نص",
    "VideoBlock": "فديو",
    "GalleryBlock": "معرض صور",
    "FileBlock": "ملف",
    "DeleteBlock": "حذف القسم",
    "EnglishVideo": "الفديو الأجنبي",
    "ArabicVideo": "الفيديو العربي",
    "EnglishGallery": "المعرض الأجنبي",
    "ArabicGallery": "المعرض العربي",
    "BlogView": "عرض المقال",
    "PasteLink": "الصق الرابط هنا",
    "Pinned": "مثبتة",
    "ContentSettings": "إعدادات المحتوى",
    "ShowMainImage": "اظهار الصورة الرئيسية",
    "ReadMore": "إقرأ المزيد",
    "FAQs": "الأسئلة الشائعة",
    "RelatedBlogs": "مقالات ذات صلة",
    "Fav": "مفضل",
    "FavoriteQuestions": "أسئلة مفضلة",
    "PreferredTypes": "اختر نمط الأسئلة",
    "NotAnsweredQuestionBefore": "اسئلة غير محلولة من قبل",
    "AnsweredQuestionBefore": "اسئلة محلولة من قبل",
    "NeedHintText": "إذا كنت بحاجة لبعض المساعدة يمكنك حذف بعض الخيارات",
    "DeleteSomeAnswers": "حذف بعض الخيارات",
    "CmaAgreeToTerm": "الموافقة على الشروط",
    "CmaAgreeToTermText1": "اتفاق السرية",
    "CmaAgreeToTermText2": "أشهد بموجب هذا أنني لن أفصح عن محتوى هذا الاختبار، ولن أقوم بإزالة أي مواد أو ملاحظات أو مواد اختبارية أخرى من قاعة الاختبار. أدرك أن عدم الامتثال لهذه الشهادة قد يؤدي إلى إبطال درجاتي وعدم أهليتي للامتحانات المستقبلية. بالنسبة لأولئك المعتمدين بالفعل من قبل معهد المحاسبين الإداريين المعتمدين، فإن عدم الالتزام بالبيان سيعتبر انتهاكًا لبيان IMA للممارسة المهنية الأخلاقية وقد يؤدي إلى إلغاء الشهادة.",
    "CmaAgreeToTermText3": "بالنقر فوق 'أوافق على هذه الشروط'، فإنك تؤكد أنك تقبل شروط هذه الاتفاقية. إذا لم تقبل شروط هذه الاتفاقية، فيجب عليك النقر فوق الزر 'خروج' وسيتم إنهاء اختبارك.",
    "CmaIacceptTerms": "أنا أقبل هذه الشروط",
    "PageRequiresScrolling": "تتطلب هذه الصفحة التمرير للأسفل",
    "CmaConfirmFinish": "تأكيد الانتهاء",
    "CmaFinishExam": "إذا قمت بتحديد إنهاء، فسيتم إرسال إجاباتك ولن تتمكن من العودة إلى الاختبار.",
    "CmaFinishExamNotAllQuestionsNoFlags": "لم تحاول الإجابة على جميع الأسئلة في هذا الاختبار",
    "CmaFinishExamNotAllQuestionswithFlags": "لم تقم بالإجابة على جميع الأسئلة في هذا الاختبار، وتم وضع علامة على بعضها.",
    "CmaAreYouSureFinishExam": "هل أنت متأكد من رغبتك في إنهاء الاختبار؟",
    "FilterBy": "تصنيف بواسطة",
    "Unattempted": "غير محلول",
    "NotAttempted": "غير محلول",
    "UnSeen": "غير مرئي",
    "Attempted": "محلول",
    "E": "م",
    "Calculator": "آلة حاسبة",
    "CopyExam": "نسخ الامتحان",
    "QuestionsDistribution": "توزيع بالأسئلة",
    "RatioDistribution": "توزيع بالنسبة",
    "EXAM_PARENT_INACTIVE": "لا يمكن تغير الحالة لأن الأب غير فعال",
    "Steps": "الخطوات",
    "UploadVideos": "تحميل الفيديوهات",
    "UploadBooks": "تحميل الكتب",
    "VideoInfo": "معلومات الفيديو",
    "BookInfo": "معلومات الملف",
    "PowerPoint": "باوربوينت",
    "Word": "وورد",
    "Excel": "إكسل",
    "PDF": "بي دي إف",
    "ZipFile": "ملف مضغوط (ZIP)",
    "CourseResources": "موارد الدورات",
    "ResourceInfo": "معلومات المورد",
    "EnglishFile": "الملف الأجنبي",
    "ArabicFile": "الملف العربي",
    "ChooseCourses": "اختر الكورسات",
    "ResourceFileRequired": "ارفع الملف الأجنبي أولاً، فهو مطلوب.",
    "ResourceCoursesRequired": "اختر كورساً واحداً على الأقل.",
    "ResourceDeleteConfirm": "سيُحذف هذا المورد من كل الكورسات المرتبط بها. هل أنت متأكد؟",
    "ResourceUploadHint": "PDF أو Word أو Excel أو PowerPoint أو ZIP، حتى 500 ميجابايت",
    "CourseResourcesLead": "الملفات التي تظهر للطالب في تبويب «الموارد» في صفحة الكورس، لمن تتضمن باقته ميزة «موارد الدورة».",
    "ResourceDetails": "بيانات المورد",
    "ResourceFiles": "الملفات",
    "ResourceFileAr": "عربي",
    "ResourceFileEn": "إنجليزي",
    "ResourceCoursesEditHint": "لتعديل الكورسات استخدم زر «الكورسات» في الجدول.",
    "Optional": "اختياري",
    "OpenFile": "فتح الملف",
    "RemoveFile": "إزالة الملف",
    "ResourceDropHere": "اسحب الملف إلى هنا أو اضغط لاختياره",
    "ResourceReplaceFile": "اسحب ملفاً آخر أو اضغط لاستبداله",
    "ResourceUploading": "جارٍ الرفع… {{percent}}%",
    "ResourceUploadFailed": "تعذّر رفع الملف، حاول مرة أخرى.",
    "ResourceBadType": "نوع الملف غير مدعوم. المسموح: PDF أو Word أو Excel أو PowerPoint أو ZIP.",
    "ResourceTooLarge": "حجم الملف أكبر من 500 ميجابايت.",
    "TheAnswerOfRequirment": "الجواب على هذا الطلب",
    "SearchOptions": "بحث في الخيارات",
    "Length": "الطول",
    "PolicyInfo": "معلومات السياسة",
    "Policy": "السياسة",
    "IAgreeOnPackagePolicy": "أوافق على سياسة هذه الباقة",
    "EnglishTransition": "الانتقال الأجنبي",
    "ArabicTransition": "الانتقال العربي",
    "PackagesPolicies": "سياسات الباقات",
    "UsersPerformances": "أداء الطلاب",
    "Whatsapp": "واتساب",
    "Notes": "ملاحظات",
    "EnglishContent": "المحتوى الأجنبي",
    "ArabicContent": "المحتوى العربي",
    "AddLink": "اضافة رابط",
    "LinkCopied": "تم نسخ الرابط",
    "SendingEmailsText": "جار الارسال, قد تأخذ العملية بضع دقائق",
    "SendingEmailsError": "حدث خطأ في ارسال بعض النتائج",
    "SendingEmailsFinish": "تم الانتهاء من عملية الارسال",
    "RUN_PARENT_EXAM": "لا يمكن تشغيل فحص من هذا النوع, يرجى التواصل مع إدارة الموقع",
    "PackagesCategories": "أصناف الباقات",
    "NoLink": "لا يمكن توليد رابط",
    "LinkIsCopied": "تم نسخ الرابط",
    "OverallPerformance": "الأداء الكلي",
    "IncludeFields": "تضمين الحقول",
    "Companies": "الشركات",
    "Hide": "اخفاء",
    "GoldenCert2": "الدورة التحضيرية لاختبار زمالة جمعية المحاسبين القانونيين المعتمدين البريطانية ACCA(قريباً)",
    "CompaniesReport": "تقرير الشركات",
    "CompanySize": "حجم الشركة",
    "JobTitle": "اسم الوظيفة",
    "JobLevel": "المستوى الوظيفي",
    "TrainNeeds": "حاجات التدريب",
    "AdminNotes": "ملاحظات المدير",
    "Employees": "الموظفون",
    "Small": "صغيرة",
    "Medium": "متوسطة",
    "Enterprise": "كبيرة",
    "Entry": "مبتدئ",
    "Mid": "متوسط ​​المستوى",
    "Senior": "محترف",
    "Manager": "مدير",
    "CompaniesCourses": "كورسات صفحة الشركات",
    "Initial": "أولي",
    "ExpireOn": "ينتهي",
    "FREE": "مجاني",
    "PAID": "مدفوع",
    "DEMO": "تجريبية",
    "TOP_SELL": "الأكثر مبيعاً",
    "PREFERRED": "المفضلة",
    "GOLD_PROMIS": "وعد ذهبي",
    "SILVER_PROMIS": "وعد فضي",
    "CONT_PROMIS": "وعد مستمر",
    "Uploaded": "تم الرفع",
    "Ready": "جاهز",
    "Badge": "شارة",
    "Badges": "الشارات",
    "UserBadges": "شارات المستخدمين",
    "UserBadge": "شارة المستخدم",
    "UserBadgeInfo": "معلومات شارة المستخدم",
    "BadgeInfo": "معلومات الشارة",
    "UserCertAttendanceInfo": "معلومات شهادة حضور المستخدم",
    "CertAttendance": "شهادة الحضور",
    "CertsAttendance": "شهادات الحضور",
    "CertAttendanceInfo": "معلومات شهادة الحضور",
    "UserCertAttendance": "شهادة حضور المستخدم",
    "UserCertsAttendance": "شهادات حضور المستخدمين",
    "EnglishUsername": "اسم المستخدم الأجنبي",
    "ArabicUsername": "اسم المستخدم العربي",
    "BadgesAndAttendance": "الشارات و شهادات الحضور",
    "DUPLICATE_ENTRY": "هذه البيانات موجودة من قبل",
    "EnglishCertAttendance": "شهادة الحضور الأجنبي",
    "ArabicCertAttendance": "شهادة الحضور العربي",
    "LandingBadgesText": "انضم إلى ليرنينغ-غو الآن واحصل على شهادتك الخاصة",
    "Provider": "المزود",
    "ExpirationDate": "تاريخ الانتهاء",
    "IssueDate": "تاريخ الاصدار",
    "Recipient": "المستلم",
    "DoesNotExpire": "لا تنتهي",
    "Learning-Go": "ليرنينغ-غو",
    "GenerateBadge&Attendance": "إنشاء شارة وشهادة حضور",
    "Download": "تحميل",
    "Completed": "مكتمل",
    "BADGE_LIMIT_EXCEED": "الشارة مولدة من قبل",
    "BADGE_COND_FAILED": "لم تطبق الشروط بعد",
    "BADGE_SUBSCR_MISSED": "اشتراك لا يدعم هذه الميزة",
    "CERT_ATTEND_LIMIT_EXCEED": "الشهادة مولدة من قبل",
    "CERT_ATTEND_COND_FAILED": "لم تطبق الشروط بعد",
    "CERT_ATTEND_SUBSCR_MISSED": "اشتراكك لا يدعم هذه الميزة",
    "Copy": "نسخ",
    "BadgeBlockText": "مبروك لـ {{user}} على إكمال {{course}}!",
    "GeneratFailed": "فشل عملية التوليد",
    "ResetExams": "مسح محاولات الفحص",
    "BageFormNoChange": "لن تتمكن من تغيير الاسم في المستقبل",
    "UpdatedAt": "تحديث في",
    "UpdatedBy": "تحديث بواسطة",
    "Sector": "القطاع",
    "Software": "برمجي",
    "Education": "تعليمي",
    "Financial": "مالي",
    "Representatives": "الممثلون",
    "Representative": "الممثل",
    "Proposals": "التقديمات",
    "Proposal": "التقديم",
    "Company": "الشركة",
    "Orders": "الطلبات",
    "Participants": "المشاركون",
    "TrainMode": "نمط التدريب",
    "Sessions": "الجلسات",
    "Budget": "الميزانية",
    "HearAboutUs": "كيف سمعت بنا",
    "NeedCustomize": "يحتاج تخصيص",
    "TheCode": "الرمز",
    "Private": "خاص",
    "Present": "حضور",
    "Online": "عن بعد",
    "Registered": "تسجيل",
    "Mix": "منوع",
    "En_En": "انكليزي-انكليزي",
    "En_Ar": "انكليزي-عربي",
    "Ar_Ar": "عربي-عربي",
    "Worksheets": "أوراق العمل",
    "Document": "مستند",
    "Links": "روابط",
    "Process": "تنفيذ",
    "Contact": "تواصل",
    "Meet": "اجتماع",
    "PrepareOffer": "تحضير عرض",
    "SendOffer": "ارسال عرض",
    "ModifyOffer": "تعديل عرض",
    "StartCourse": "بدء الكورس",
    "CollectCash": "تحصيل الأموال",
    "BuisnessCertification": "دورة شهادة الأعمال",
    "BuisnessProfCourse": "دورة الأعمال الاحترافية",
    "BusinessRequests": "طلبات الأعمال",
    "CiaMakeSureScrollDown": "تأكد من عرض كل المعلومات الموجودة بالتمرير للأسفل",
    "InvisibleContent": "محتوى غير مرئي",
    "MarkFlag": "تمييز السؤال للمراجعة",
    "ReviewAll": "مراجعة الكل",
    "ReviewUnAttempted": "مراجعة غير المكتمل",
    "ReviewNotAttempted": "مراجعة غير المكتمل",
    "ReviewFlagged": "مراجعة المميز بعلامة",
    "Instructions": "ارشادات",
    "CiaSummaryInstructionsText1": "فيما يلي ملخص جميع إجاباتك. يمكنك مراجعة أسئلتك بثلاث طرق مختلفة.",
    "CiaSummaryInstructionsText2": "المفاتيح في الزاوية في الأسفل تحتوي على تلك الخيارات:",
    "CiaSummaryInstructionsText3": "مراجعة كل الأسئلة - إضغط لمراجعة جميع الأسئلة و الأجوبة.",
    "CiaSummaryInstructionsText4": "مراجعة الأسئلة الغير مكتملة - إضغط لمراجعة الأسئلة التي تُركَت غير مكتملة.",
    "CiaSummaryInstructionsText5": "مراجعة البنود المؤشر عليها - إضغط لمراجعة الأسئلة التي تم وضع علامة عليها للمراجعة ( إضغط على رمز العلم لتغيير وضع التأشير للمراجعة).",
    "CiaSummaryInstructionsText6": "عند انتهائك من المراجعة , يمكنك ضغط زر انهاء. عند الضغط على زر انهاء سوف تخرج من الامتحان نهائيا وتبدأ باستكمال الاستبيان. هام: بمجرد انتهائك من المراجعة لن تكون قادرا على العودة إلى هذه الشاشة أو أي شاشة سابقة.",
    "ClickNextToStartReview": "إضغط التالي لتبدأ المراجعة",
    "StartReview": "إبدأ المراجعة",
    "All": "الكل",
    "CiaFinishExam": "بمجرد انهائك المراجعة فإنك لن تكون قادرا على العودة إلى الاختبار",
    "CiaFinishExamUnattempted": "لقد اخترت انهاء المراجعة الحالية, لكن يوجد {{count}} سؤال غير مكتمل. اذا نقرت فوق نعم لن تكون هناك امكانية للعودة إلى هذه المراجعة.",
    "ExamReview": "مراجعة الامتحان",
    "ShowFact": "عرض سيناريو المقال",
    "HideFact": "اخفاء سيناريو المقال",
    "CmaTutorialPage1Text1": "محاكاة امتحان CMA",
    "CmaTutorialPage1Text2": "هيكل الامتحان",
    "CmaTutorialPage1Text3": "يحتوي هذا المحاكاة لامتحان CMA على:",
    "CmaTutorialPage1Text4": "١٠٠ سؤال اختيار من متعدد، مُقدّمة في قسم محتوى واحد (١). لديك ١٨٠ دقيقة لإكمال الامتحان.",
    "CmaTutorialPage1Text5": "سؤالان مقاليان مُقسَّمان إلى قسمين (2) للمحتوى. لديك 60 دقيقة لإكمال الامتحان.",
    "CmaTutorialPage1Text6": "يرجى ملاحظة أن الغرض من محاكاة الاختبار هذه هو إعطاؤك إحساسًا بتجربة الاختبار كما سيكون في مركز الاختبار.",
    "CmaTutorialPage1Text7": "يرجى العلم أنه في امتحان شهادة CMA، سيكون لديك قسمان للمحتوى، وسيكون لديك 4 ساعات لإكمالهما. القسم الأول (1) من أسئلة الاختيار من متعدد، وسيكون لديك 3 ساعات لإكماله. يجب عليك الإجابة على 50% على الأقل من أسئلة الاختيار من متعدد بشكل صحيح للانتقال إلى أقسام المقالات في الامتحان. أما القسم الثاني (2) من المحتوى، فسيتضمن مقالتين وأسئلة ذات صلة. سيكون هناك استبيان بعد الامتحان في امتحان شهادة CMA.",
    "CmaTutorialPage1Text8": "قبل البدء، يُنصح بشدة بمراجعة البرنامج التعليمي لبضع دقائق قبل محاولة الإجابة على أي أسئلة في الامتحان. يُقدم البرنامج التعليمي لمحة عامة عن الميزات المتاحة لك أثناء الامتحان.",
    "CmaTutorialPage1Text9": "يرجى ملاحظة أن النقر على زر 'إنهاء الاختبار' واختيار 'إنهاء الامتحان' في أي وقت أثناء الامتحان سيؤدي إلى إنهاء الامتحان بالكامل. أي أسئلة غير مكتملة ستُعتبر غير صحيحة.",
    "CmaTutorialPage2Text1": "مرحباً بكم في البرنامج التعليمي",
    "CmaTutorialPage2Text2": "يقدم هذا البرنامج التعليمي سلسلة من الشاشات التي تُرشدك إلى بيئة اختبار الحاسوب. ستتعلم كيفية استخدام الفأرة وأجزاء الشاشة المختلفة.",
    "CmaTutorialPage2Text3": "لاحظ المؤقت أعلى الشاشة. سيظهر عرض مشابه أثناء الامتحان الفعلي. على يسار الشاشة، توجد قائمة مرقمة تُظهر موقعك في سلسلة أسئلة الامتحان (أو في هذه الحالة، شاشات البرنامج التعليمي). سيتم شرح ميزات الشاشة الأخرى لاحقًا في البرنامج التعليمي.",
    "CmaTutorialPage2Text4": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage3Text1": "استخدام الماوس",
    "CmaTutorialPage3Text2": "يتحرك مؤشر الماوس عند تحريكه على سطح ما. ورغم اختلاف أشكاله، إلا أن السهم الموضح أعلاه هو الأكثر شيوعًا. للإشارة بالماوس، حرّك المؤشر حتى يستقر على العنصر المطلوب. للنقر على عنصر، أشر إليه ثم اضغط زر الماوس الأيسر بسرعة ثم حرّره.",
    "CmaTutorialPage3Text3": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage4Text1": "التنقل عبر الامتحان",
    "CmaTutorialPage4Text2": "انقر على زر 'التالي' أسفل الشاشة للانتقال إلى الشاشة أو السؤال التالي. انقر على زر 'الرجوع' للانتقال إلى الشاشة أو السؤال السابق.",
    "CmaTutorialPage4Text3": "بالإضافة إلى أزرار التنقل، يمكنك استخدام الأزرار المرقمة المعروضة على يسار الشاشة. بناءً على عدد الأسئلة في القسم، قد تحتاج إلى النقر على السهم المتجه للأسفل للانتقال إلى أسئلة إضافية.",
    "CmaTutorialPage4Text4": "تتغير مظهر الأزرار المرقمة للإشارة إلى حالات سؤال مختلفة: الحالية، والمُحاولة، وغير المُحاولة، والمُعلمة.",
    "CmaTutorialPage4Text5": "سيتم الإشارة إلى السؤال الحالي بواسطة زر مرقم على شكل سهم.",
    "CmaTutorialPage4Text6": "بالنسبة لجميع الأسئلة التي تمت محاولتها، سيظهر الزر المرقم بلون أغمق.",
    "CmaTutorialPage4Text7": "بالنسبة لجميع الأسئلة غير المجاب عليها، سيظل الزر المرقم بنفس اللون الأصلي.",
    "CmaTutorialPage4Text8": "ستظهر الأسئلة المميزة رمز العلم على الزر المرقم.",
    "CmaTutorialPage4Text9": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage5Text1": "استخدام وظيفة التمرير",
    "CmaTutorialPage5Text2": "عندما لا يتناسب السؤال مع شاشة واحدة، سيظهر التحذير التالي في أسفل الشاشة.",
    "CmaTutorialPage5Text3": "للتمرير عبر محتويات الشاشة، انقر واسحب شريط التمرير حسب الحاجة أو استخدم عجلة التمرير الموجودة على الماوس.",
    "CmaTutorialPage5Text4": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage6Text1": "الوقت المتبقي",
    "CmaTutorialPage6Text2": "يتم عرض مقدار الوقت المتبقي في الجزء العلوي من الشاشة.",
    "CmaTutorialPage6Text3": "لكل قسم من هذا الامتحان وقت محدد، بما في ذلك الدرس التوضيحي. كما يُخصص وقت إجمالي لموعد الامتحان الكامل. بالضغط على الساعة، يتم التبديل بين الوقت المتبقي في القسم الحالي من الامتحان والوقت المتبقي في جميع أقسام المحتوى، إن وجدت.",
    "CmaTutorialPage6Text4": "أهم عرض للوقت بالنسبة لك كمتقدم للاختبار هو 'الوقت المتبقي للقسم'.",
    "CmaTutorialPage6Text5": "لاحظ أنه، حيثما ينطبق ذلك، سيظهر مربع تنبيه أسفل ساعة الامتحان للإشارة إلى متى يتبقى 30 دقيقة، و15 دقيقة، و5 دقائق في القسم الحالي.",
    "CmaTutorialPage6Text6": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage7Text1": "الأسئلة المعلمة",
    "CmaTutorialPage7Text2": "يمكنك وضع علامة على سؤال كتذكير بالرجوع والتحقق من إجابتك أو محاولة الإجابة عليها لاحقًا.",
    "CmaTutorialPage7Text3": "لتوضيح سؤال ما، انقر فوق زر التوضيح الموجود أسفل شاشة الامتحان.",
    "CmaTutorialPage7Text4": "ستظهر أيقونة العلم على الزر المرقّم لأي سؤال مُعلّم للمراجعة، كما هو موضح أدناه. انقر على زر العلم مرة أخرى لإزالة العلم.",
    "CmaTutorialPage7Text5": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage8Text1": "الإجابة على أسئلة الاختيار من متعدد",
    "CmaTutorialPage8Text2": "يستخدم هذا الاختبار أسئلة اختيار من متعدد. لهذا النوع من الأسئلة إجابة واحدة صحيحة.",
    "CmaTutorialPage8Text3": "لإكمال كل سؤال من أسئلة الاختيار من متعدد، انقر على الخيار الذي تعتقد أنه الإجابة الأنسب. بعد اختياره، سيظهر الخيار بلون أغمق. لتغيير إجابتك، انقر على خيار آخر. إذا أردت إلغاء اختيار أحد الخيارات، فانقر عليه مرة أخرى.",
    "CmaTutorialPage8Text4": "تدرب على إجابة سؤال الاختيار من متعدد أدناه. بعد الانتهاء من التدرب، انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage8Text5": "من المستويات البيولوجية التالية للتنظيم، ما هو الذي يمثل المستوى الأصغر أو الأدنى؟",
    "CmaTutorialPage8Text6": "النظام البيئي",
    "CmaTutorialPage8Text7": "الخلية",
    "CmaTutorialPage8Text8": "السكان",
    "CmaTutorialPage8Text9": "الكائن الحي",
    "CmaTutorialPage9Text1": "استخدام الآلة الحاسبة",
    "CmaTutorialPage9Text2": "تتوفر آلة حاسبة لكل سؤال في الامتحان. تشبه هذه الآلة الحاسبة الآلة الحاسبة الموجودة في نظام مايكروسوفت ويندوز.",
    "CmaTutorialPage9Text3": "يمكنك استخدام الآلة الحاسبة لإجراء أيٍّ من العمليات الحسابية القياسية التي تستخدمها عادةً باستخدام الآلة الحاسبة اليدوية. تُجري الآلة الحاسبة عمليات حسابية أساسية، مثل الجمع والطرح والضرب والقسمة.",
    "CmaTutorialPage9Text4": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage10Text1": "تمييز النص",
    "CmaTutorialPage10Text2": "أثناء الامتحان، ستتمكن من تحديد نصوص الأسئلة التي ترى أهمية الرجوع إليها أثناء تقدمك في الامتحان. سيبقى التحديد ظاهرًا أثناء تصفحك للامتحان، إلا إذا اخترت إزالته.",
    "CmaTutorialPage10Text3": "لتمييز النص، انقر واسحب مؤشر الماوس فوق النص المطلوب. انقر على زر 'تمييز'، كما هو موضح في الصورة أدناه، والذي يظهر بعد تحرير زر الماوس. لإزالة النص، انقر على أي منطقة من النص المحدد، ثم انقر على زر 'تمييز' مرة أخرى.",
    "CmaTutorialPage10Text4": "لا يمكن تطبيق ميزة التمييز على النص الموجود ضمن خيارات الإجابة.",
    "CmaTutorialPage10Text5": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage11Text1": "خيارات الشطب",
    "CmaTutorialPage11Text2": "أثناء الامتحان، تتوفر ميزة الشطب لمساعدتك على استبعاد الخيارات الممكنة بصريًا. سيبقى خيار الشطب موجودًا أثناء تقدمك في الامتحان، ما لم تختر إزالته.",
    "CmaTutorialPage11Text3": "انقر بزر الماوس الأيمن على خيار لشطبه. انقر بزر الماوس الأيمن مرة أخرى لإزالة الشطب. انقر بزر الماوس الأيسر على خيار مشطوب لتحديده كإجابة. يمكنك شطب أي عدد أو عدد من العناصر كما تشاء.",
    "CmaTutorialPage11Text4": "تدرب على استخدام ميزة 'الشطب' أدناه. بعد الانتهاء، انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage11Text5": "كم عدد الرئتين في جسم الإنسان الطبيعي؟",
    "CmaTutorialPage11Text6": "واحد",
    "CmaTutorialPage11Text7": "اثنان",
    "CmaTutorialPage11Text8": "ثلاثة",
    "CmaTutorialPage11Text9": "أربعة",
    "CmaTutorialPage12Text1": "مراجعة القسم",
    "CmaTutorialPage12Text2": "أثناء الامتحان، يمكنك مراجعة حالة جميع الأسئلة في قسم الامتحان الحالي باستخدام أيقونة الشبكة",
    "CmaTutorialPage12Text3": "تقع في الزاوية اليسرى السفلية من شاشة الامتحان.",
    "CmaTutorialPage12Text4": "للانتقال مباشرةً إلى سؤال، انقر على الرمز المرقّم المقابل. يمكنك أيضًا تصفية عرضك حسب الأسئلة غير المُجرّبة، والمُجرّبة، والمُعلّمة. يُمكن قفل قسم المراجعة باستخدام رمز القفل وإغلاقه باستخدام رمز 'X'.",
    "CmaTutorialPage12Text5": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage13Text1": "انتهاء الامتحان",
    "CmaTutorialPage13Text2": "بعد إكمال جميع الأسئلة ومراجعتها، يمكنك إنهاء الاختبار بالنقر على زر 'إنهاء الاختبار' في أعلى يمين الشاشة. بعد النقر، ستظهر نافذة منبثقة تُؤكد رغبتك في إنهاء الاختبار. انقر على زر 'إنهاء' لإرسال إجاباتك.",
    "CmaTutorialPage13Text3": "سيؤدي الضغط على زر 'إنهاء الاختبار' خلال أي جزء من الاختبار إلى إنهائه. بمجرد مغادرة قسم المحتوى، لا يُسمح لك بالعودة. سيتم تصنيف أي أسئلة غير مكتملة على أنها غير صحيحة.",
    "CmaTutorialPage13Text4": "انقر على زر 'التالي' للمتابعة.",
    "CmaTutorialPage14Text1": "خاتمة البرنامج التعليمي",
    "CmaTutorialPage14Text2": "بهذا نختتم الدرس. يمكنك مراجعة الدرس بالنقر على زر 'رجوع' لنسخ شاشة واحدة كل مرة، أو باستخدام الأزرار المرقمة على يسار الشاشة. يمكنك مشاهدة الدرس في أي وقت أثناء الامتحان بالنقر على أيقونة علامة الاستفهام. تظهر هذه الأيقونة أسفل يسار الشاشة بعد بدء الاختبار.",
    "CmaTutorialPage14Text3": "أتمنى لك حظا سعيدا في الامتحان.",
    "CmaTutorialPage14Text4": "انقر فوق زر 'بدء الاختبار' للخروج من البرنامج التعليمي وبدء الاختبار.",
    "CMAExamSimulation": "محاكاة امتحان CMA",
    "FinishTest": "انهاء الاختبار",
    "StartTheTest": "ابدأ الامتحان",
    "ContinueTheTest": "متابعة الاختبار",
    "MandatoryPassQuestions": "أسئلة النجاح الإلزامية",
    "Page": "الصفحة",
    "Test": "الاختبار",
    "Candidate": "المرشح",
    "FinishReview": "انهاء المراجعة",
    "Wrong": "خاطئ",
    "SectionTimeRemaining": "الوقت المتبقي للقسم",
    "Banners": "اللافتات",
    "Banner": "اللافتة",
    "BannerInfo": "معلومات اللافتة",
    "EnglishButton": "الزر الأجنبي",
    "ArabicButton": "الزر العربي",
    "Accredits": "الاعتمادات",
    "Accredit": "الاعتماد",
    "AccreditInfo": "معلومات الاعتماد",
    "AccreditedBy": "معتمدون من قبل",
    "QuestionsOrder": "ترتيب الأسئلة",
    "EnglishSource": "المصدر الأجنبي",
    "ArabicSource": "المصدر العربي",
    "Theory": "نظري",
    "Practical": "عملي",
    "Easy": "سهل",
    "Hard": "صعب",
    "Knowledge": "معرفة",
    "Comprehension": "فهم",
    "Application": "تطبيق",
    "Analysis": "تحليل",
    "Synthesis": "تركيب",
    "Evaluation": "تقييم",
    "TotalFilteredQuestions": "عدد الاسئلة المفلترة الكلي",
    "CopyPackage": "نسخ الباقة",
    "QuestionConcept": "مفهوم السؤال",
    "KnowledgeDesc": "اختبار القدرة على حفظ المواد",
    "ComprehensionDesc": "اختبار القدرة على فهم المواد المحفوظة",
    "ApplicationDesc": "اختبار القدرة على استخدام المواد التي تم تعلمها في مواقف محددة",
    "AnalysisDesc": "اختبر قدرتك على تمييز العلاقات السببية. ميّز بين السلوكيات، وحدد العناصر التي تدعم حكمًا ما.",
    "SynthesisDesc": "اختبار القدرة على ربط الأفكار وصياغة الفرضيات",
    "EvaluationDesc": "اختبار القدرة على إصدار الأحكام واختيار مسار العمل",
    "EnglishReadMore": "قراءة المزيد الأجنبي",
    "ArabicReadMore": "قراءة المزيد العربي",
    "ShowReadMoreAfterFirstBlock": "إظهار خيار 'اقرأ المزيد' بعد القسم الأول",
    "CpaFinishExamHeader": "لقد تخطيت سؤالاً واحدًا أو أكثر في الاختبار",
    "CpaFinishExamText": "انقر فوق 'إرسال الاختبار' لتأكيد إرساله، أو انقر فوق رقم السؤال أعلاه لإكمال عملك، لن تتمكن من العودة إلى هذا الاختبار بعد النقر فوق 'إرسال الاختبار'",
    "ReturnToTestlet": "العودة إلى الاختبار",
    "Save&Close": "حفظ وإغلاق",
    "NavigateTo": "انتقل إلى",
    "Overview": "ملخص",
    "CorrectAnswerUnit": "واحدة الإجابة",
    "CalculatedValueInstructions": "تعليمات القيمة المحسوبة",
    "CalculatedValueInstructionsText1": "يمكنك استخدام 5 عمليات أساسية:",
    "CalculatedValueInstructionsText2": "+، -، *، / و ^",
    "CalculatedValueInstructionsText3": "يمكنك استخدام '(' و ')' للأولوية",
    "CalculatedValueInstructionsText4": "يجب أن تكون المتغيرات عبارة عن رقم الخلية، على سبيل المثال: c[1] تعني الخلية الأولى في الجدول",
    "CalculatedValueInstructionsText5": "مثال على المعادلة: ((c[1]+c[2])-c[3])^2",
    "CalculatedValueInstructionsText6": "لا تضيف أي مسافات في معادلتك",
    "ResetPerformance": "مسح الأداء",
    "UsePlaceholdersText": "استخدم العناصر النائبة التالية في القالب الخاص بك لتخصيص النتائج",
    "FactsCount": "عدد المقالات",
    "EnglishRealName": "الاسم الحقيقي الأجنبي",
    "ArabicRealName": "الاسم الحقيقي العربي",
    "PackagesPacks": "حزم الباقات",
    "PackInfo": "معلومات الحزمة",
    "RequiredUserOrEmail": "المستخدم أو البريد الالكتروني مطلوب",
    "RequiredPackOrPackage": "الحزمة أو الباقة مطلوبة",
    "RelatedCoursesOptions": "خصائص الكورسات المرتبطة",
    "PdfToggleSidebar": "إظهار/إخفاء الشريط الجانبي",
    "PdfFind": "بحث",
    "PdfPreviousPage": "الصفحة السابقة",
    "PdfNextPage": "الصفحة التالية",
    "PdfPage": "صفحة",
    "PdfOf": "من",
    "PdfZoomOut": "تصغير",
    "PdfZoomIn": "تكبير",
    "PdfAutomaticZoom": "تكبير تلقائي",
    "PdfActualSize": "الحجم الفعلي",
    "PdfPageFit": "ملائمة الصفحة",
    "PdfPageWidth": "عرض الصفحة",
    "PdfHighlightText": "تمييز النص",
    "PdfHighlightColor": "لون التمييز",
    "PdfYellow": "أصفر",
    "PdfGreen": "أخضر",
    "PdfPink": "وردي",
    "PdfBlue": "أزرق",
    "PdfRemoveHighlight": "إزالة التمييز",
    "PdfStrikethroughText": "شطب النص",
    "PdfTools": "أدوات",
    "PdfGoToFirstPage": "الانتقال إلى الصفحة الأولى",
    "PdfGoToLastPage": "الانتقال إلى الصفحة الأخيرة",
    "PdfRotateClockwise": "تدوير باتجاه عقارب الساعة",
    "PdfRotateAntiClockwise": "تدوير عكس عقارب الساعة",
    "PdfTextSelectionTool": "أداة تحديد النص",
    "PdfHandTool": "أداة اليد",
    "PdfDocumentProperties": "خصائص المستند...",
    "PdfSearchInDocument": "البحث في المستند...",
    "PdfNoMatches": "لا توجد نتائج",
    "PdfPrevious": "السابق (Shift+Enter)",
    "PdfNext": "التالي (Enter)",
    "PdfHighlightAll": "تمييز الكل",
    "PdfMatchCase": "مطابقة حالة الأحرف",
    "PdfClose": "إغلاق",
    "PdfErrorLoad": "تعذر عرض الملف — قد يكون الملف تالفا أو هناك مشكلة في الاتصال بالإنترنت. حاول مجددا.",
    "Of": "من",
    "SymbolCopied": "تم نسخ الرمز الذي اخترته يمكنك لصقه في أي مكان تريده",
    "ItemReviewScreenExplained": "شاشة مراجعة الأسئلة موضحة",
    "ExamSection": "قسم الاختبار",
    "ItemReviewScreen": "شاشة مراجعة الأسئلة",
    "ItemReviewScreenText1": "تعرض هذه الشاشة حالة الإشارة (العَلم) لكل سؤال بالإضافة إلى حالات الأسئلة التالية:",
    "ItemReviewScreenText2": "تمت المحاولة - لقد حاولت الإجابة على السؤال.",
    "ItemReviewScreenText3": "لم تُحاول - لقد شاهدت السؤال ولكن لم تحاول الإجابة عليه.",
    "ItemReviewScreenText4": "غير مُشاهد - لم تقم بمشاهدة السؤال بعد.",
    "ItemReviewScreenText5": "لن يكون هناك أي إشارة تُظهر ما إذا كانت إجاباتك صحيحة أو غير صحيحة. يجب عليك الرجوع إلى مواد الحلول للحصول على الإرشاد لتقييم أدائك بنفسك.",
    "ItemReviewScreenText6": "يمكنك اختيار أسئلة فردية للمراجعة من خلال النقر على رقم السؤال.",
    "ItemReviewScreenText7": "يمكنك أيضًا استخدام الأزرار الموجودة أسفل الشاشة لمراجعة مجموعات من الأسئلة بسرعة.",
    "ItemReviewScreenText8": "أثناء المراجعة يمكنك تغيير الإجابات أو حالة الإشارة للأسئلة، وعند العودة إلى شاشة مراجعة الأسئلة، سيتم عرض أي تحديثات للحالة.",
    "DifrFinishExamUnattempted": "لقد اخترت إنهاء المراجعة الحالية، ولكن هناك {{count}} من الأسئلة غير المكتملة. إذا نقرت على نعم، فلن تتمكن من العودة إلى هذه المراجعة.",
    "DifrFinishExamText1": "لقد اخترت إنهاء هذا الاختبار، إذا تابعت، فلن تتمكن من العودة إلى هذا الاختبار.",
    "DifrFinishExamText2": "هل أنت متأكد أنك تريد إنهاء هذا الاختبار؟",
    "EndExam": "انهاء الاختبار",
    "DifrTutorialPage1Text1": "تعليمات (1 من 4)",
    "DifrTutorialPage1Text2": "التعليمات أدناه تمثل تلك المعروضة في الاختبار الفعلي. سيتم شرح أي اختلافات بين هذا الاختبار والاختبار الفعلي.",
    "DifrTutorialPage1Text3": "تعليمات عامة",
    "DifrTutorialPage1Text4": "في هذا الاختبار، كما هو الحال في الاختبار الفعلي، ستكون شاشات التعليمات متاحة لمدة 10 دقائق كحد أقصى قبل بدء الاختبار.",
    "DifrTutorialPage1Text5": "سيبدأ وقت الاختبار المحدد تلقائيًا بعد انتهاء فترة العشر دقائق (أو في وقت أبكر إذا اخترت بدء الاختبار أثناء هذه الفترة).",
    "DifrTutorialPage1Text6": "يمكنك الوصول إلى نسخة من شاشات التعليمات في أي وقت أثناء الاختبار من خلال النقر على زر 'المساعدة' المقدم.",
    "DifrTutorialPage1Text7": "بيئة العمل",
    "DifrTutorialPage1Text8": "يتكون اختبارك من عدد من الأسئلة. يتم عرض كل سؤال في بيئة عمل. كل بيئة عمل تتضمن:",
    "DifrTutorialPage1Text9": "معلومات تمهيدية عن السؤال.",
    "DifrTutorialPage1Text10": "المرفقات - تحتوي على سيناريو السؤال مقسّم إلى أقسام أو مصادر معلومات ستحتاجها للإجابة على متطلبات السؤال.",
    "DifrTutorialPage1Text11": "المتطلبات - تسرد المتطلبات التي يجب إكمالها في بيئة العمل.",
    "DifrTutorialPage1Text12": "خيارات الإجابة - سيتم تقديم خيار أو أكثر من",
    "DifrTutorialPage1Text13": "معالجة النصوص و/أو الجداول لإنشاء إجابتك.",
    "DifrTutorialPage1Text14": "عند التحديد، ستظهر العناصر والمتطلبات وخيارات الإجابة في نوافذ يمكن نقلها وتغيير حجمها حسب الحاجة.",
    "DifrTutorialPage1Text15": "يمكنك إغلاق كل نافذة على حدة أو جميع النوافذ مرة واحدة من خلال تحديد علامة x.",
    "DifrTutorialPage1Text16": "تظهر ميزة 'إغلاق الكل' في شريط الأدوات العلوي. هذا يقلل النوافذ المفتوحة إلى الجانب الأيسر من الشاشة. سيتم حفظ أي إجابات قمت بإدخالها، ويمكنك إعادة فتحها وتغييرها في أي وقت.",
    "DifrTutorialPage1Text17": "يوجد شريط تقسيم يمكنك استخدامه لرؤية المزيد أو القليل من الجانب الأيسر أو الأيمن من الشاشة حسب الحاجة.",
    "DifrTutorialPage1Text18": "يمكنك تمييز أو شطب النص في المعلومات التمهيدية أو مرفقات PDF أو المتطلبات من خلال تحديد 'تمييز' أو 'شطب'.",
    "DifrTutorialPage1Text19": "يمكنك النسخ واللصق بين المرفقات والمتطلبات وخيارات الإجابة باستخدام اختصارات Ctrl-C (نسخ) و Ctrl-V (لصق). ملاحظة: عند اللصق في جدول في الاختبار الفعلي، يجب عليك",
    "DifrTutorialPage1Text20": "النقر مرتين على الخلية أو اللصق مباشرة في شريط الصيغة. في هذا الاختبار، يجب اللصق في الجدول عن طريق تحديد الخلية.",
    "DifrTutorialPage2Text1": "تعليمات (2 من 4)",
    "DifrTutorialPage2Text2": "التنقل",
    "DifrTutorialPage2Text3": "يتم عرض رقم السؤال الذي تقوم بعرضه في شريط العرض العلوي. يمكنك إخفاء هذا العرض أو استعادته عن طريق تحديد <icon/>",
    "DifrTutorialPage2Text4": "يمكنك التنقل بين الشاشات من خلال تحديد <icon1/> أو <icon2/> أو عن طريق النقر على رقم سؤال من شاشات التنقل أو مراجعة العناصر.",
    "DifrTutorialPage2Text5": "يمكنك الرجوع إلى الأسئلة وتغيير إجابتك في أي وقت أثناء الاختبار.",
    "DifrTutorialPage2Text6": "إشارة للمراجعة",
    "DifrTutorialPage2Text7": "إذا كنت ترغب في مراجعة سؤال لاحقًا أثناء الاختبار، انقر على <icon/> 'إشارة للمراجعة'.",
    "DifrTutorialPage2Text8": "انقر على الزر مرة أخرى لإزالة الإشارة.",
    "DifrTutorialPage2Text9": "المساعدة",
    "DifrTutorialPage2Text10": "انقر على زر 'المساعدة' للوصول إلى:",
    "DifrTutorialPage2Text11": "نسخة من هذه التعليمات الخاصة بالاختبار.",
    "DifrTutorialPage2Text12": "مساعدة وإرشادات حول بيئة العمل",
    "DifrTutorialPage2Text13": "أوراق الصيغ/جداول الضرائب إذا كان اختبارك يتطلبها. لاحظ أن اسم زر المساعدة سيوضح ما إذا كانت أوراق الصيغ/جداول الضرائب متاحة أي <icon/>.",
    "DifrTutorialPage2Text14": "الآلة الحاسبة",
    "DifrTutorialPage2Text15": "لديك خيار استخدام الآلة الحاسبة القياسية على الشاشة من خلال تحديد <icon/>.",
    "DifrTutorialPage2Text16": "لاحظ أنه في الاختبار الفعلي يُسمح لك أيضًا باستخدام آلتك الحاسبة الخاصة طالما أنها لا تحتوي على إمكانية تخزين أو عرض النص.",
    "DifrTutorialPage3Text1": "تعليمات (3 من 4)",
    "DifrTutorialPage3Text2": "الملاحظات / ورقة العمل",
    "DifrTutorialPage3Text3": "يمكنك استخدام ورقة العمل على الشاشة لتدوين الملاحظات/الحسابات من خلال تحديد <icon/>.",
    "DifrTutorialPage3Text4": "يمكنك قص ونسخ النص من ورقة العمل ولصقه في خيارات الإجابة باستخدام اختصارات Ctrl-C (نسخ)، Ctrl-X (قص) و Ctrl-V (لصق)، أو الأزرار الموجودة على الشاشة.",
    "DifrTutorialPage3Text5": "تحتفظ ورقة العمل بجميع الملاحظات/الحسابات المُدخلة لجميع بيئات العمل وتظل متاحة طوال مدة الاختبار. لن يتم إرسالها للتصحيح بعد الاختبار الفعلي.",
    "DifrTutorialPage3Text6": "سيتم توفير ورقة ملاحظات/حسابات ورقية لك أيضًا في الاختبار الفعلي إذا كنت تفضل استخدامها. لن يتم إرسالها للتصحيح، وسيتم جمعها في نهاية الاختبار ويجب عدم إخراجها من قاعة الاختبار.",
    "DifrTutorialPage3Text7": "هام:",
    "DifrTutorialPage3Text8": "لن يتم تصحيح الملاحظات/الحسابات المُدخلة على ورقة العمل أو على الورقة الورقية خلال الاختبار الفعلي.",
    "DifrTutorialPage3Text9": "إذا كنت تريد للمصحح أن يرى أي ملاحظات/حسابات، يجب عليك تضمينها ضمن خيارات الإجابة ذات الصلة.",
    "DifrTutorialPage3Text10": "الرموز",
    "DifrTutorialPage3Text11": "يمكنك إضافة مجموعة من رموز العملات إلى إجاباتك من خلال تحديد <icon/> في شريط الأدوات العلوي.",
    "DifrTutorialPage3Text12": "شاشة التنقل",
    "DifrTutorialPage3Text13": "يمكن الوصول إلى شاشة التنقل في أي وقت أثناء الاختبار من خلال تحديد <icon/>.",
    "DifrTutorialPage3Text14": "تتيح لك هذه الشاشة الانتقال مباشرة إلى أي رقم سؤال في الاختبار.",
    "DifrTutorialPage3Text15": "كما تتيح لك معرفة حالة كل سؤال سواء تم عرضه، أو تمت محاولة الإجابة عليه، أو تم وضع إشارة عليه للمراجعة.",
    "DifrTutorialPage4Text1": "تعليمات (4 من 4)",
    "DifrTutorialPage4Text2": "مراجعة الاختبار",
    "DifrTutorialPage4Text3": "يمكنك مراجعة هذا الاختبار بمجرد أن تكون قد حاولت الإجابة على أي من الأسئلة أو جميعها.",
    "DifrTutorialPage4Text4": "للقيام بذلك:",
    "DifrTutorialPage4Text5": "انتقل إلى آخر سؤال في الاختبار.",
    "DifrTutorialPage4Text6": "انقر على <icon/>.",
    "DifrTutorialPage4Text7": "سينقلك هذا إلى شاشة مراجعة العناصر.",
    "DifrTutorialPage4Text8": "شاشة مراجعة العناصر",
    "DifrTutorialPage4Text9": "تمنحك هذه الشاشة فرصة لرؤية حالة الإشارة والمحاولة لجميع الأسئلة ومراجعة إجاباتك قبل الخروج نهائيًا من الاختبار.",
    "DifrTutorialPage4Text10": "يمكنك تحديد أسئلة فردية ترغب في مراجعتها، أو الوصول بسرعة إلى مجموعات من الأسئلة من خلال شاشة مراجعة العناصر.",
    "DifrTutorialPage4Text11": "خلال فترة مراجعة العناصر، لا تتوفر شاشة التنقل، ومع ذلك يمكنك التنقل بين الأسئلة من خلال تحديد التالي <icon1/>، <icon3/> السابق أو <icon2/> شاشة المراجعة.",
    "DifrTutorialPage4Text12": "عند مراجعة الأسئلة، يمكنك تغيير إجابتك والنقر على شاشة المراجعة لرؤية الحالة المحدثة على شاشة مراجعة العناصر.",
    "DifrTutorialPage4Text13": "يمكنك مراجعة إجاباتك مقابل مواد الحل ذات الصلة المقدمة على المنصة.",
    "DifrTutorialPage4Text14": "إنهاء الاختبار",
    "DifrTutorialPage4Text15": "بمجرد الانتهاء من مراجعة العناصر وترغب في إنهاء الاختبار نهائيًا، انقر على 'إنهاء الاختبار' من شاشة مراجعة العناصر.",
    "DifrTutorialPage4Text16": "بمجرد إنهاء الاختبار، لا يمكنك العودة إلى أي سؤال.",
    "DifrTutorialPage4Text17": "حدد 'التالي' للانتقال إلى شاشة ملخص الاختبار.",
    "DifrTutorialPage5Text1": "ملخص الاختبار",
    "DifrTutorialPage5Text2": "الوقت المسموح به: هذا الاختبار التجريبي محدد بوقت.",
    "DifrTutorialPage5Text3": "يتضمن هذا الاختبار 4 أسئلة، كل منها بقيمة 25 درجة.",
    "DifrTutorialPage5Text4": "100 درجة في المجموع.",
    "DifrTutorialPage5Text5": "جميع الأسئلة إلزامية.",
    "DifrTutorialPage5Text6": "هام:",
    "DifrTutorialPage5Text7": "في الاختبار الفعلي، يجب عليك:",
    "DifrTutorialPage5Text8": "إدخال إجابتك لكل سؤال في خيارات الإجابة المقدمة لذلك السؤال. لن يتم تصحيح أي إجابات تُدخل في خيارات مخصصة لسؤال مختلف.",
    "DifrTutorialPage5Text9": "تحديد المتطلب الذي ترتبط به كل من إجاباتك حتى يكون واضحًا للمصححين.",
    "DifrTutorialPage5Text10": "عرض جميع الملاحظات/الحسابات التي ترغب أن يراها المصحح ضمن إجاباتك. تذكر أن أي ملاحظات/حسابات مدخلة على ورقة العمل أو على ورقة حساباتك لن يتم تصحيحها.",
    "DifrTutorialPage5Text11": "انقر على 'التالي' لبدء الاختبار.",
    "WorkspaceHelp": "مساعدة مساحة العمل",
    "ExamInstructions": "تعليمات الامتحان",
    "DifrUnseenContent": "محتوى غير مرئي",
    "DifrUnseenContentText1": "لم تشاهد الشاشة كاملةً بعد.",
    "DifrUnseenContentText2": "يرجى استخدام كافة أشرطة التمرير و/أو فتح أي معروضات على الشاشة قبل المحاولة مرة أخرى.",
    "ResetPopup.Title": "Reset Confirmation",
    "ResetPopup.reset": "Reset",
    "ResetPopup.Message": "Are you sure you want to reset? Resetting will remove any response you have made on this item and reset back to an unanswered state.",
    "ResetPopup.OK": "OK",
    "ResetPopup.Cancel": "Cancel",
    "ResetPopup.yes": "Yes",
    "ResetPopup.no": "No",
    "PackageReceipt.Title": "تأكيد استلام الباقة",
    "PackageReceipt.Message": "هل استلمت محتوى باقة الاشتراك الخاصة بك؟",
    "PackageReceipt.Yes": "نعم، استلمتها",
    "PackageReceipt.No": "تواصل مع فريقنا",
    "PackageReceipt.AckCheckbox": "أؤكد تفعيل الخدمة وتمكّني من الوصول إلى المحتوى.",
    "AckStatus": "حالة الاستلام",
    "AckStatus.PENDING": "قيد الانتظار",
    "AckStatus.SEEN": "تمت المشاهدة",
    "AckStatus.CONFIRMED": "مؤكد",
    "NeedConfirmation": "يتطلب تأكيد الاستلام",
    "Emails": "البريد الالكتروني (متعدد)",
    "CountryCode": "رمز الدولة",
    "Pack": "الحزمة",
    "Results": "النتائج",
    "Ranks": "الترتيب",
    "QATAR": "قطر",
    "UAE": "الإمارات",
    "PaymentLead": "عميل الدفع",
    "pageDifr": {
      "toolbar": {
        "symbol": "Symbol",
        "highlight": "Highlight",
        "strikethrough": "Strikethrough",
        "calculator": "Calculator",
        "scratchPad": "Scratch Pad",
        "closeAll": "Close All",
        "flag": "Flag",
        "favorite": "Favorite"
      },
      "sidebar": {
        "exhibits": "Exhibits",
        "correctAnswer": "Correct Answer",
        "explanation": "Explanation",
        "requirements": "Requirements",
        "marks": "Marks",
        "responseOptions": "Response Options",
        "wordProcessor": "Word Processor",
        "spreadsheet": "Spreadsheet"
      },
      "modals": {
        "reportProblem": "Report a Problem",
        "scratchPad": "Scratch Pad",
        "calculator": "Calculator",
        "comingSoon": "Coming Soon",
        "symbol": "Symbol",
        "wordProcessor": "Word Processor",
        "spreadsheet": "Spreadsheet",
        "answerOfRequirement": "The answer of this requirement"
      }
    },
    "examFooter": {
      "buttons": {
        "help": "Help",
        "reviewAnswers": "Review Answers",
        "exit": "Exit",
        "endExam": "End Exam",
        "back": "Back",
        "navigator": "Navigator",
        "next": "Next"
      },
      "review": {
        "reviewAll": "Review All",
        "reviewNotAttempted": "Review Not Attempted",
        "reviewFlagged": "Review Flagged"
      },
      "modals": {
        "endExamTitle": "End Exam",
        "unattemptedWarning": "You have chosen to end the current review, but there are {{count}} incomplete questions. If you click Yes, you will not be able to return to this review.",
        "finishText1": "You have chosen to end this exam, If you continue, you will NOT be able to return to this exam.",
        "finishText2": "Are you sure you want to end this exam?",
        "comingSoon": "Coming Soon"
      },
      "common": {
        "yes": "YES",
        "no": "NO"
      },
      "navigator": {
        "title": "Navigator",
        "question": "Question",
        "status": "Status",
        "flagged": "Flagged",
        "attempted": "Attempted",
        "notAttempted": "Not Attempted",
        "unseen": "Unseen"
      },
      "help": {
        "title": "Help",
        "workspaceHelp": "Workspace Help",
        "examInstructions": "Exam Instructions"
      }
    },
    "excelMenu": {
      "edit": {
        "title": "Edit",
        "undo": "Undo",
        "redo": "Redo",
        "cut": "Cut",
        "copy": "Copy",
        "paste": "Paste",
        "pasteSpecial": "Paste Special...",
        "copyFormat": "Copy Cell Format",
        "find": "Find...",
        "replace": "Replace...",
        "selectAll": "Select All"
      },
      "format": {
        "title": "Format",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "rowHeight": "Row Height",
        "columnWidth": "Column Width",
        "numberFormat": "تنسيق الأرقام"
      }
    },
    "customExcelToolbarItems": {
      "reset": "Reset",
      "cut": "Cut",
      "copy": "Copy",
      "paste": "Paste",
      "numberFormat": "تنسيق الأرقام"
    },
    "excelModals": {
      "common": {
        "ok": "OK",
        "cancel": "Cancel"
      },
      "pasteSpecial": {
        "title": "Paste Special",
        "pasteLabel": "Paste",
        "formulas": "Formulas",
        "values": "Values",
        "formats": "Formats",
        "all": "All"
      },
      "rowHeight": {
        "title": "Row Height",
        "heightLabel": "Height",
        "auto": "Auto",
        "custom": "Custom",
        "pixels": "Pixels"
      },
      "columnWidth": {
        "title": "Column Width",
        "widthLabel": "Width",
        "auto": "Auto",
        "custom": "Custom",
        "pixels": "Pixels"
      }
    },
    "v2": {
      "modal": {
        "close": "إغلاق"
      },
      "checkout": {
        "title": "إتمام الاشتراك",
        "duration": "مدة الاشتراك: {{days}} يوم",
        "code": "كود الخصم",
        "codePlaceholder": "أدخل الكود إن وُجد",
        "applyCode": "تطبيق",
        "codeApplied": "تم تطبيق كود الخصم.",
        "codeNoDiscount": "هذا الكود لا يمنح خصماً على هذه الباقة.",
        "codeInvalid": "كود الخصم غير صالح.",
        "price": "السعر",
        "discount": "الحسم",
        "codeDiscount": "حسم كود الخصم",
        "total": "المجموع",
        "free": "مجاناً",
        "agree": "أوافق على سياسة هذه الباقة",
        "showPolicy": "عرض السياسة",
        "hidePolicy": "إخفاء السياسة",
        "policyLoading": "جارٍ التحميل…",
        "policyEmpty": "لا يوجد نص مضاف لسياسة هذه الباقة.",
        "secure": "آلية الدفع آمنة، وبياناتك مشفّرة وسرّية.",
        "pay": "متابعة إلى الدفع",
        "confirm": "تأكيد الاشتراك",
        "subscriptions": "الاشتراكات",
        "back": "رجوع"
      },
      "student": {
        "nav": {
          "subscriptions": "الاشتراكات"
        },
        "menu": {
          "label": "قائمة الحساب",
          "profile": "معلومات الملف الشخصي",
          "language": "تغيير اللغة",
          "signOut": "تسجيل خروج"
        },
        "notifications": {
          "title": "الإشعارات",
          "latest": "آخر الإشعارات",
          "nothingNew": "لا توجد إشعارات جديدة حالياً",
          "nothingNewHint": "ستظهر هنا الإشعارات غير المقروءة فور وصولها.",
          "withCount": "الإشعارات — {{count}} غير مقروء",
          "clearAll": "مسح الكل",
          "loadMore": "تحميل المزيد",
          "empty": "لا توجد إشعارات بعد.",
          "important": "إشعارات جديدة",
          "dismiss": "حسناً"
        },
        "deck": {
          "previous": "السابق",
          "next": "التالي"
        },
        "pagination": {
          "label": "التنقل بين الصفحات",
          "page": "الصفحة {{page}}",
          "summary": "عرض {{shown}} من إجمالي {{total}}"
        },
        "home": {
          "metaTitle": "الرئيسية | Learning-Go Education",
          "account": "حسابي"
        },
        "subscriptions": {
          "metaTitle": "الاشتراكات | Learning-Go Education",
          "title": "الاشتراكات",
          "lead": "اعرض جميع مشترياتك وحالة اشتراكك وتراخيصك وفواتيرك من مكان واحد.",
          "empty": "لا توجد باقات متاحة حالياً.",
          "packagesFailed": "تعذّر تحميل الباقات المتاحة. حدّث الصفحة للمحاولة مجدداً.",
          "active": "نشط",
          "inactive": "غير نشط",
          "notSubscribed": "غير مشترك",
          "startsAt": "يبدأ بـ:",
          "endsAt": "ينتهي بـ:",
          "duration": "المدة:",
          "days": "{{days}} يوم",
          "price": "السعر:",
          "free": "مجاناً",
          "features": "الميزات",
          "policies": "السياسات",
          "payNow": "ادفع الآن",
          "renew": "تجديد الاشتراك",
          "subscribe": "اشترك الآن",
          "paid": "✓ مدفوع ${{amount}}",
          "due": "المستحق ${{amount}}",
          "loadingDetails": "جارٍ التحميل…",
          "noDetails": "لا توجد تفاصيل مضافة لهذه الباقة."
        },
        "courses": {
          "title": "تابع التعلم",
          "progress": "التقدم الإجمالي {{percent}}%",
          "expiresOn": "ينتهي {{date}}",
          "continue": "متابعة الدراسة",
          "empty": "لم تشترك في أي مادة بعد.",
          "browseCertificates": "تصفح الشهادات"
        },
        "course": {
          "metaTitle": "{{name}} | Learning-Go Education",
          "metaTitleFallback": "المادة | Learning-Go Education",
          "loading": "جارٍ التحميل…",
          "noCourse": "لم نجد هذه المادة بين اشتراكاتك.",
          "backToDashboard": "العودة إلى الرئيسية",
          "actions": {
            "banks": "بنوك التدريب",
            "banksLead": "تدرب على الأسئلة من هذا البنك",
            "periodic": "الاختبارات الدورية",
            "periodicLead": "تدرب على الاختبارات الدورية",
            "mock": "اختبارات المحاكاة التجريبية",
            "mockLead": "اختبر نفسك في بيئة محاكاة حقيقية"
          },
          "tabs": {
            "label": "أقسام المادة",
            "chapters": "فصول الكتاب",
            "history": "سجل الاختبارات",
            "performance": "الأداء",
            "resources": "الموارد"
          },
          "chapters": {
            "title": "فصول الكتاب",
            "lead": "استعرض فصول الكتاب والمواضيع التي يتضمنها كل فصل وتقدمك في كل منها",
            "empty": "لا توجد فصول مضافة لهذه المادة بعد.",
            "percent": "{{percent}}%",
            "done": "مكتمل",
            "continue": "متابعة"
          },
          "history": {
            "title": "سجل الاختبارات",
            "lead": "راجع جميع الاختبارات التي أكملتها، واطّلع على نتائجك ومحاولاتك السابقة.",
            "empty": "لم تُكمل أي اختبار في هذه المادة بعد.",
            "name": "اسم الفحص",
            "startsAt": "يبدأ بـ",
            "endsAt": "ينتهي بـ",
            "type": "النوع",
            "questions": "الأسئلة",
            "grade": "الدرجة النهائية",
            "result": "النتيجة",
            "more": "المزيد",
            "passed": "ناجح",
            "failed": "غير ناجح",
            "pending": "قيد التصحيح",
            "summary": "عرض {{shown}} من إجمالي {{total}} فحص",
            "retake": "إعادة الاختبار",
            "review": "مراجعة الاختبار",
            "analysis": "تحليل النتائج",
            "retakeWrong": "الأسئلة التي لم تُجب عنها بشكل صحيح ({{count}})",
            "retakeFlagged": "الأسئلة المُعلَّمة ({{count}})",
            "retakeUnanswered": "الأسئلة غير المُجاب عنها ({{count}})"
          },
          "results": {
            "title": "تقرير نتائج اختبار {{name}}",
            "titleNamed": "تقرير نتائج {{name}}",
            "titleFallback": "تقرير نتائج الاختبار",
            "metaTitle": "تقرير نتائج {{name}}",
            "breadcrumb": "تحليل النتائج",
            "breadcrumbLabel": "مسار الصفحة",
            "notFound": "لم نجد هذا الاختبار في موادك.",
            "backToHistory": "العودة إلى سجل الاختبارات",
            "options": "خيارات التقرير",
            "part": "القسم {{number}}",
            "partTyped": "القسم {{number}} ({{type}})",
            "reviewExam": "مراجعة الاختبار كاملاً",
            "chapters": {
              "title": "الأداء حسب الفصل",
              "empty": "لا توجد نتائج على مستوى الفصول لهذا الاختبار.",
              "unavailable": "تعذّر تحميل نتائج الفصول الآن. نتيجتك الإجمالية لا تتأثر، حاول فتح التقرير لاحقاً.",
              "chapter": "الفصل {{ordinal}}",
              "ordinals": [
                "الأول",
                "الثاني",
                "الثالث",
                "الرابع",
                "الخامس",
                "السادس",
                "السابع",
                "الثامن",
                "التاسع",
                "العاشر",
                "الحادي عشر",
                "الثاني عشر",
                "الثالث عشر",
                "الرابع عشر",
                "الخامس عشر",
                "السادس عشر",
                "السابع عشر",
                "الثامن عشر",
                "التاسع عشر",
                "العشرون"
              ]
            },
            "bands": {
              "review": "يحتاج مراجعة",
              "average": "أداء متوسط",
              "good": "أداء جيد"
            },
            "overall": {
              "title": "النتيجة الإجمالية",
              "scored": "الدرجة المحرزة",
              "passing": "درجة النجاح",
              "ringLabel": "النتيجة {{percent}}%، {{grade}}"
            },
            "grades": {
              "excellent": "ممتاز",
              "veryGood": "جيد جداً",
              "good": "جيد",
              "fair": "مقبول",
              "weak": "دون المطلوب"
            },
            "distribution": {
              "title": "توزيع الإجابات والأسئلة",
              "total": "إجمالي الأسئلة",
              "correct": "إجابات صحيحة",
              "flagged": "أسئلة معلَّمة",
              "unanswered": "أسئلة غير مجابة",
              "wrong": "إجابات خاطئة"
            },
            "units": {
              "title": "تحليل الوحدات الدراسية",
              "empty": "لا توجد دروس في هذا الفصل.",
              "topic": "موضوع الدرس",
              "score": "الدرجة",
              "questions": "عدد الأسئلة",
              "wrong": "أجوبة خاطئة",
              "unanswered": "أسئلة غير محلولة",
              "correct": "أجوبة صحيحة",
              "more": "المزيد",
              "review": "مراجعة",
              "reviewLabel": "مراجعة أسئلة {{topic}}"
            }
          },
          "performance": {
            "title": "أداؤك وتقدّمك",
            "lead": "تابع مستوى تقدّمك في البرنامج، وراقب نتائجك وأداءك في مختلف الفصول والاختبارات.",
            "empty": "لا توجد بيانات أداء لهذه المادة بعد.",
            "complete": "مكتمل",
            "percentComplete": "{{percent}}% مكتمل",
            "units": "الوحدات الدراسية",
            "curriculum": "أداء المنهج العلمي",
            "questions": "أداء الأسئلة",
            "total": "المجموع النهائي",
            "score": "{{score}} / 100",
            "examRow": "{{name}} — الجزء {{part}}"
          },
          "resources": {
            "title": "الموارد التعليمية",
            "lead": "استكشف المواد والملفات التعليمية التي تساعدك على فهم المحتوى وتعزيز استعدادك للشهادة.",
            "empty": "لا توجد ملفات مرفقة بهذه المادة بعد.",
            "download": "تحميل",
            "downloadLabel": "تحميل {{name}}",
            "size": "{{size}} ميجابايت",
            "sizeKb": "{{size}} كيلوبايت"
          },
          "materials": {
            "empty": "لا يوجد محتوى في هذا الموضوع بعد.",
            "periodicTitle": "الاختبارات الدورية",
            "attempts": "{{parts}} جزء — المحاولات {{used}} / {{allowed}}",
            "questions": "{{count}} سؤال",
            "video": "فيديو",
            "book": "ملف",
            "mcq": "أسئلة الاختيار من متعدد",
            "essay": "الأسئلة المقالية",
            "tbs": "المحاكاة المبنية على المهام",
            "file": "المحاكاة المبنية على الملفات"
          }
        },
        "bank": {
          "metaTitle": "{{name}} | Learning-Go Education",
          "results": {
            "title": "تقرير نتائج {{name}}",
            "backToSetup": "العودة إلى إنشاء اختبار"
          },
          "breadcrumbLabel": "مسار الصفحة",
          "training": "التدريب والاختبارات",
          "create": "إنشاء اختبار مخصص",
          "stepsLabel": "خطوات إنشاء الاختبار",
          "stepDone": "مكتملة",
          "questionsCount": "{{count}} سؤال",
          "steps": {
            "topics": {
              "title": "اختيار أسئلة الفحص",
              "lead": "اختر وحدة ومواضيع",
              "heading": "الخطوة ١ - اختيار أسئلة الفحص",
              "intro": "اختر وحدة وفصلاً لتضمينه في {{bank}}."
            },
            "modes": {
              "title": "اختر نمط الأسئلة",
              "lead": "حدد النوع والصعوبة والحالة",
              "heading": "اختر نمط الأسئلة"
            },
            "settings": {
              "title": "إعدادات الاختبار",
              "lead": "إنهاء وبدء",
              "heading": "عدد الأسئلة والفرز"
            }
          },
          "topics": {
            "units": "اختر الفصل",
            "selectAll": "تحديد الكل",
            "selectAllUnits": "تحديد مواضيع كل الفصول",
            "selectAllTopics": "تحديد كل مواضيع {{unit}}"
          },
          "modes": {
            "legend": "حالة الأسئلة",
            "unanswered": "أسئلة غير محلولة من قبل",
            "answered": "أسئلة محلولة من قبل",
            "favourite": "الأسئلة المفضلة",
            "categories": "الأصناف",
            "difficulties": "الصعوبات",
            "concepts": "مفهوم السؤال",
            "total": "عدد الأسئلة المفلترة الكلي: {{count}}",
            "counting": "جارٍ حساب عدد الأسئلة…",
            "theory": "نظري",
            "practical": "عملي",
            "easy": "سهل",
            "medium": "متوسطة",
            "hard": "صعب",
            "knowledge": "معرفة",
            "comprehension": "فهم",
            "application": "تطبيق",
            "analysis": "تحليل",
            "synthesis": "تركيب",
            "evaluation": "تقييم"
          },
          "settings": {
            "summary": "المواضيع : {{topics}} . الأسئلة : {{questions}} ( الحد الأقصى : {{max}} )",
            "count": "أدخل عدد الأسئلة التي تريد مراجعتها",
            "questions": "سؤال",
            "increase": "زيادة عدد الأسئلة",
            "decrease": "إنقاص عدد الأسئلة",
            "order": "ترتيب ظهور الأسئلة",
            "standard": "ترتيب قياسي",
            "standardLead": "عرض الأسئلة متسلسلة حسب ترتيبها الأصلي في المنهج",
            "random": "ترتيب عشوائي",
            "randomLead": "خلط عشوائي للأسئلة في كل مرة تبدأ فيها هذا الاختبار",
            "name": "اسم الفحص",
            "namePlaceholder": "أدخل اسم الفحص..."
          },
          "previous": "السابق",
          "next": "التالي",
          "start": "ابدأ امتحانك",
          "starting": "جارٍ بدء الاختبار…"
        },
        "knowledgeTest": {
          "results": {
            "title": "تقرير نتائج اختبار المعرفة: {{topic}}",
            "titleFallback": "تقرير نتائج اختبار المعرفة",
            "course": "المادة",
            "backToCourse": "العودة إلى المادة",
            "backToBook": "العودة إلى الكتاب"
          }
        },
        "profile": {
          "metaTitle": "الملف الشخصي | Learning-Go Education",
          "title": "معلومات الملف الشخصي",
          "lead": "قم بمراجعة معلوماتك الشخصية المسجلة",
          "male": "ذكر",
          "female": "أنثى",
          "avatarEdit": "تعديل صورة الملف الشخصي",
          "avatarUploading": "جارٍ الرفع…",
          "avatarSaved": "تم تحديث صورة الملف الشخصي.",
          "avatarFailed": "تعذّر تحديث الصورة. حاول مرة أخرى.",
          "avatarType": "الصيغ المقبولة: JPG أو PNG فقط.",
          "avatarSize": "حجم الصورة يجب ألا يتجاوز 10 ميغابايت."
        },
        "password": {
          "title": "تغيير كلمة المرور",
          "lead": "قم بتحديث أمان حسابك",
          "sending": "جارٍ الإرسال…",
          "sent": "أرسلنا رابط تغيير كلمة المرور إلى {{email}}. تفقّد بريدك."
        },
        "form": {
          "personal": {
            "title": "معلومات شخصية",
            "lead": "بياناتك الشخصية المسجلة لدينا."
          },
          "contact": {
            "title": "معلومات الاتصال",
            "lead": "الطريقة التي نتواصل بها معك."
          },
          "account": {
            "title": "إجراءات الحساب",
            "lead": "إدارة الوصول إلى حسابك وبياناتك."
          },
          "firstName": "الاسم الأول",
          "lastName": "اسم العائلة",
          "email": "عنوان البريد الإلكتروني",
          "phone": "رقم التليفون",
          "signOut": {
            "title": "تسجيل الخروج",
            "lead": "قم بتسجيل الخروج من حسابك على هذا الجهاز."
          },
          "support": {
            "title": "تعديل معلومات الحساب",
            "lead": "هل تحتاج إلى تعديل معلومات حسابك؟ تواصل مع فريق الدعم وسنساعدك في تحديث بياناتك بكل سهولة وأمان.",
            "action": "تواصل مع الدعم"
          }
        }
      },
      "auth": {
        "common": {
          "or": "أو",
          "backToSignin": "العودة لتسجيل الدخول"
        },
        "fields": {
          "mobile": "رقم الجوال",
          "firstName": "الاسم الأول",
          "lastName": "اسم العائلة",
          "email": "البريد الإلكتروني",
          "password": "كلمة المرور",
          "confirmPassword": "تأكيد كلمة المرور",
          "country": "الدولة",
          "gender": "الجنس",
          "male": "ذكر",
          "female": "أنثى",
          "enterHere": "أدخل هنا",
          "emailPlaceholder": "أدخل بريدك الإلكتروني",
          "passwordPlaceholder": "أدخل كلمة المرور",
          "newPasswordPlaceholder": "أنشئ كلمة مرور قوية",
          "confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
          "countryPlaceholder": "اختر الدولة",
          "countrySearch": "ابحث عن دولة",
          "showPassword": "إظهار كلمة المرور",
          "hidePassword": "إخفاء كلمة المرور"
        },
        "social": {
          "google": "المتابعة بحساب جوجل",
          "apple": "متابعة باستخدام Apple"
        },
        "signin": {
          "metaTitle": "تسجيل الدخول | Learning-Go Education",
          "title": "تسجيل الدخول إلى حسابك",
          "lead": "مرحباً بعودتك! تابع بإدخال بيانات تسجيل الدخول",
          "forgot": "نسيت كلمة المرور؟",
          "submit": "تسجيل الدخول",
          "submitting": "جارٍ تسجيل الدخول...",
          "noAccount": "لا تملك حساب؟ <signup>قم بإنشاء حساب</signup>"
        },
        "signup": {
          "metaTitle": "إنشاء حساب | Learning-Go Education",
          "title": "أنشئ حسابك المجاني",
          "lead": "أنشئ حسابك وابدأ رحلتك التعليمية نحو أفضل الشهادات المهنية.",
          "submit": "إنشاء حساب",
          "submitting": "جارٍ إنشاء الحساب...",
          "haveAccount": "لديك حساب بالفعل؟ <signin>تسجيل الدخول</signin>",
          "consent": "بالمتابعة، فإنك تقر بأنك تفهم وتوافق على <terms>الشرط والأحكام</terms> و <privacy>سياسة الخصوصية</privacy>"
        },
        "profile": {
          "metaTitle": "أكمل بياناتك | Learning-Go Education",
          "title": "أكمل بياناتك الشخصية",
          "lead": "يرجى ملء المعلومات لإنشاء حساب جديد",
          "submit": "إرسال"
        },
        "wizard": {
          "progress": "خطوات إنشاء الحساب",
          "personal": "المعلومات الشخصية",
          "contact": "معلومات التواصل",
          "security": "الأمان",
          "next": "التالي",
          "previous": "السابق"
        },
        "otp": {
          "metaTitle": "رمز التحقق | Learning-Go Education",
          "title": "أدخل رمز التحقق",
          "lead": "لقد أرسلنا رمز تحقق مكون من {{length}} أرقام إلى:",
          "submit": "تحقق",
          "submitting": "جارٍ التحقق...",
          "resend": "إعادة إرسال الرمز",
          "resendIn": "إعادة الإرسال بعد {{countdown}}",
          "changeEmail": "تغيير البريد الإلكتروني",
          "changeNumber": "تغيير رقم الجوال"
        },
        "forgot": {
          "metaTitle": "نسيت كلمة المرور | Learning-Go Education",
          "title": "نسيت كلمة المرور؟",
          "lead": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
          "submit": "إرسال الرابط",
          "submitting": "جارٍ الإرسال..."
        },
        "checkEmail": {
          "metaTitle": "تفقّد بريدك الإلكتروني | Learning-Go Education",
          "title": "تفقّد بريدك الإلكتروني",
          "lead": "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. {{email}}. يرجى تفقد صندوق الوارد للمتابعة.",
          "leadNoEmail": "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى تفقد صندوق الوارد للمتابعة.",
          "submit": "العودة لتسجيل الدخول"
        },
        "reset": {
          "metaTitle": "كلمة مرور جديدة | Learning-Go Education",
          "title": "أنشئ كلمة مرور جديدة",
          "lead": "اختر كلمة مرور قوية لحسابك، ثم احفظها في مكان آمن.",
          "submit": "حفظ",
          "submitting": "جارٍ الحفظ..."
        }
      },
      "nav": {
        "primary": "التنقل الرئيسي",
        "home": "الرئيسية",
        "curricula": "المناهج التعليمية",
        "contact": "تواصل معنا",
        "signIn": "تسجيل دخول",
        "dashboard": "حسابي",
        "openMenu": "فتح القائمة",
        "closeMenu": "إغلاق القائمة"
      },
      "footer": {
        "links": "الروابط",
        "legal": "الصفحات القانونية",
        "contact": "اتصال",
        "contactUs": "اتصل بنا",
        "privacy": "سياسة الخصوصية",
        "terms": "الشروط والأحكام",
        "tagline": "نبني مستقبل التعلم المهني من خلال مناهج تعليمية احترافية، وكتب رقمية تفاعلية، وأدوات تساعد على الفهم، والممارسة، وقياس التقدم",
        "rights": "© {{year}} Learning-Go Education. جميع الحقوق محفوظة.",
        "location": "الموقع"
      },
      "contact": {
        "support": "الدعم",
        "sales": "المبيعات",
        "countryCity": "قطر - الدوحة",
        "street": "شارع روضة الخيل",
        "building": "منطقة 52، مبنى 1",
        "metaTitle": "تواصل معنا — Learning-Go Education",
        "metaDescription": "تواصل مع فريق Learning-Go Education أو قدّم شكوى، ونرد عليك خلال 24 ساعة.",
        "pill": "مركز الدعم",
        "title": "تواصل معنا واحصل على الدعم",
        "lead": "نحن هنا للمساعدة. تواصل مع فريقنا أو قدّم شكوى — نرد خلال 24 ساعة.",
        "tabs": {
          "message": "تواصل معنا",
          "complaint": "إرسال شكوى"
        },
        "message": {
          "title": "أرسل لنا رسالة",
          "lead": "نهدف للرد على جميع الاستفسارات خلال 24 ساعة.",
          "name": "الاسم الكامل",
          "namePlaceholder": "أدخل اسمك",
          "email": "البريد الإلكتروني",
          "emailPlaceholder": "أدخل بريدك الإلكتروني",
          "phone": "رقم الهاتف",
          "phonePlaceholder": "أدخل رقم هاتفك",
          "body": "الرسالة",
          "bodyPlaceholder": "اكتب رسالتك هنا",
          "submit": "إرسال الرسالة",
          "defaultSubject": "رسالة من صفحة التواصل"
        },
        "info": {
          "title": "تواصل معنا",
          "lead": "فريقنا مستعد لمساعدتك عبر البريد الإلكتروني أو الهاتف أو شخصياً.",
          "email": "البريد الإلكتروني",
          "phone": "الدعم الهاتفي",
          "address": "المقر الرئيسي",
          "social": "تواصل معنا"
        },
        "complaint": {
          "title": "تقديم شكوى",
          "lead": "نأخذ مخاوفكم على محمل الجد ونتعامل معها بسرية تامة.",
          "name": "الاسم الكامل",
          "namePlaceholder": "أدخل اسمك الكامل",
          "phone": "رقم الهاتف",
          "phonePlaceholder": "+974 XXXX-XXXX",
          "email": "البريد الإلكتروني",
          "emailPlaceholder": "أدخل بريدك الإلكتروني",
          "subject": "موضوع الشكوى",
          "subjectPlaceholder": "مثال: مواد دراسية مفقودة للأسبوع 3",
          "details": "تفاصيل الشكوى",
          "detailsPlaceholder": "يرجى وصف الحادثة أو المشكلة بالتفصيل...",
          "submit": "إرسال الشكوى",
          "commitmentTitle": "التزامنا",
          "commitmentBody": "Learning-Go Education ملتزمة بتوفير بيئة تعلّم عادلة وشفافة. إذا واجهت مشكلة لا ترقى لمعاييرنا، يرجى إبلاغنا.",
          "stepsTitle": "الإجراءات",
          "steps": [
            "يتم تسجيل شكواك بشكل آمن.",
            "مراجعة خلال يومي عمل.",
            "اقتراح حل خلال 5 أيام عمل."
          ],
          "privacyTitle": "نحافظ على خصوصيتك",
          "privacyBody": "جميع الطلبات مشفرة ويراجعها فقط الموظفون المخولون."
        },
        "attachments": {
          "label": "المرفقات (اختياري، {{max}} ملفات كحد أقصى)",
          "pick": "انقر للرفع أو اسحب وأفلت",
          "hint": "{{formats}} — حتى {{megabytes}} ميجابايت لكل ملف",
          "remove": "إزالة {{name}}",
          "tooMany": "يمكن إرفاق {{max}} ملفات كحد أقصى.",
          "tooLarge": "حجم كل ملف يجب ألا يتجاوز {{megabytes}} ميجابايت.",
          "badType": "الصيغ المقبولة هي {{formats}} فقط."
        },
        "form": {
          "required": "هذا الحقل مطلوب.",
          "invalidEmail": "يرجى إدخال بريد إلكتروني صحيح.",
          "sending": "جارٍ الإرسال...",
          "sent": "تم استلام رسالتك، وسنرد عليك قريباً."
        }
      },
      "social": {
        "facebook": "فيسبوك",
        "twitter": "إكس",
        "instagram": "إنستغرام",
        "youtube": "يوتيوب",
        "linkedin": "لينكدإن"
      },
      "cta": {
        "title": "ابدأ رحلتك التعليمية مع Learning-⁠Go Education",
        "lead": "سواء كنت متعلمًا فرديًا أو مؤسسة تعليمية، ستجد الحل المناسب ضمن منصة واحدة متكاملة.",
        "explore": "استكشف المناهج التعليمية",
        "contact": "تواصل معنا"
      },
      "accredited": {
        "pill": "معايير جودة معتمدة",
        "title": "معتمدون من قبل",
        "lead": "شراكاتنا الاستراتيجية مع كبرى المعاهد والمنظمات المهنية العالمية تضمن لك محتوى تعليميًا معتمدًا ومحدثًا باستمرار لمساعدتك في اجتياز اختباراتك بنجاح."
      },
      "cert": {
        "nav": {
          "accreditation": "الاعتمادات",
          "packages": "الباقات",
          "about": "عن الشهادة",
          "faq": "الأسئلة الشائعة"
        },
        "breadcrumb": "مسار التنقل",
        "sectionNav": "أقسام الصفحة",
        "notFound": "لم يتم العثور على هذه الشهادة.",
        "faqTitle": "أسئلة يتكرر طرحها",
        "hero": {
          "subtitle": "برنامج الشهادة المهنية المتكامل — ({{code}})",
          "cta": "استكشف الباقات"
        },
        "packages": {
          "title": "الباقات",
          "partsLabel": "أجزاء الشهادة",
          "featuresColumn": "الميزات والخدمات",
          "tableCaption": "مقارنة بين الباقات المتاحة والميزات التي تشملها",
          "included": "مشمول",
          "notIncluded": "غير مشمول",
          "subscribe": "اشترك الآن",
          "vatNote": "الأسعار شاملة ضريبة القيمة المضافة",
          "price": "{{price}}$/{{period}}",
          "perMonth": "شهر",
          "perYear": "سنة",
          "perDays": "{{days}} يوم",
          "free": "مجاناً"
        }
      },
      "legal": {
        "empty": "لم يُنشر محتوى هذه الصفحة بعد."
      },
      "home": {
        "metaTitle": "Learning-Go Education — منهج متكامل للشهادات المهنية",
        "metaDescription": "كتب تعليمية وبنوك أسئلة للشهادات المهنية، مصممة للأفراد وللمعاهد والمنصات التعليمية."
      },
      "hero": {
        "title": "منهج متكامل يجمع بين الكتاب،وبنك الأسئلة،وتجربة تعلّم رقمية احترافية.",
        "lead": "توفر Learning-Go Education كتبًا تعليمية وبنوك أسئلة للشهادات المهنية، مصممة للأفراد الراغبين في الاستعداد للاختبارات، وللمعاهد والمنصات التعليمية التي تبحث عن محتوى تدريبي احترافي، منظم، وقابل للاعتماد ضمن برامجها.",
        "cta": "تصفح المناهج",
        "deviceAlt": "لابتوب يعرض منصة Learning-Go Education، وحوله بطاقات: بنك الأسئلة، كتاب تفاعلي، تقدم الدراسة، أسئلة تجريبية."
      },
      "catalogue": {
        "metaTitle": "المناهج التعليمية — Learning-Go Education",
        "metaDescription": "استكشف الكتب والمناهج المهنية المصممة لدعم رحلتك التعليمية وتطوير خبراتك في المحاسبة والمالية.",
        "pill": "مكتبة Learning-Go Education",
        "title": "استكشف الكتب والمناهج المهنية",
        "lead": "اكتشف مجموعة متنوعة من الكتب والمناهج المهنية المصممة لدعم رحلتك التعليمية وتطوير خبراتك في المحاسبة والمالية.",
        "cta": "تصفح المناهج",
        "curricula": {
          "title": "مناهجنا التعليمية",
          "lead": "إصدارات تعليمية تساعدك على دراسة مفاهيم الشهادات المهنية بطريقة منظمة.",
          "empty": "لا توجد مناهج منشورة حالياً."
        },
        "card": {
          "subscribe": "اشترك الآن",
          "details": "عرض التفاصيل"
        }
      },
      "offerings": {
        "pill": "ماذا نقدم؟",
        "title": "كل ما تحتاجه للاستعداد للشهادات المهنية في منصة واحدة",
        "lead": "توفر Learning-Go Education منظومة تعليمية متكاملة تجمع بين الكتب الرقمية، والمناهج الاحترافية، وبنوك الأسئلة، ومواد المدربين، والتراخيص المؤسسية، لتقديم تجربة تعلم حديثة تلبي احتياجات الأفراد والمؤسسات.",
        "items": [
          {
            "title": "المناهج التعليمية المتكاملة",
            "body": "منصة تعليمية تجمع الكتاب الرقمي، وبنك الأسئلة، والاختبارات التدريبية، وأدوات متابعة التقدم في تجربة تعلم واحدة."
          },
          {
            "title": "باقات تحضير متكاملة",
            "body": "اختر الباقة المناسبة لاحتياجاتك، سواء كنت تبحث عن كتاب، أو منهج متكامل، أو تجربة تحضير شاملة للشهادة المهنية."
          },
          {
            "title": "كتب تعليمية احترافية",
            "body": "محتوى تعليمي منظم يشرح مفاهيم الشهادات المهنية بأسلوب واضح، مع أمثلة تطبيقية ورسوم توضيحية تساعد على بناء فهم متين للمادة."
          }
        ]
      },
      "methodology": {
        "pill": "منهجية بناء المحتوى",
        "title": "كل منهج يمر برحلة دقيقة قبل أن يصل إليك",
        "lead": "لا يتم إعداد المحتوى بشكل عشوائي، بل يمر بعدة مراحل تبدأ بتحليل متطلبات الشهادة وتنتهي بالمراجعة العلمية والتحديث المستمر، لضمان تقديم تجربة تعلم احترافية تواكب أحدث المعايير المهنية.",
        "assuranceTitle": "تم تطويره وفق أعلى المعايير المهنية",
        "assuranceLead": "يتم إعداد جميع مناهج Learning-Go Education بالتعاون مع خبراء ومتخصصين، وفق متطلبات الشهادات المهنية المعتمدة، لضمان تقديم محتوى تعليمي دقيق، حديث، وسهل التطبيق.",
        "assurances": [
          "يعتمد على المعايير الرسمية للشهادة.",
          "يُراجع بواسطة خبراء ومتخصصين.",
          "يُحدّث باستمرار لمواكبة أحدث الإصدارات.",
          "يربط بين المفاهيم النظرية والتطبيقات العملية.",
          "مصمم لتجربة تعلم رقمية متكاملة."
        ],
        "steps": [
          {
            "stage": "البحث",
            "title": "تحليل متطلبات الشهادة",
            "body": "يبدأ العمل بدراسة أحدث متطلبات الشهادة المهنية، والمراجع الرسمية، وأهداف التعلم، لضمان توافق المحتوى مع المعايير المعتمدة."
          },
          {
            "stage": "التصميم",
            "title": "تصميم هيكل المنهج",
            "body": "يتم تقسيم المحتوى إلى وحدات وفصول ومسارات تعليمية مترابطة، بما يضمن تسلسلًا منطقيًا وسهولة في التعلم."
          },
          {
            "stage": "التأليف",
            "title": "تأليف المحتوى",
            "body": "يقوم متخصصون بإعداد محتوى علمي واضح، يجمع بين الشرح النظري والأمثلة العملية، مع التركيز على تبسيط المفاهيم المعقدة."
          },
          {
            "stage": "التطبيق",
            "title": "إعداد الأمثلة والتطبيقات",
            "body": "يتم إثراء المحتوى بأمثلة واقعية وتطبيقات عملية تساعد المتعلم على ربط المعرفة النظرية بالممارسة المهنية."
          },
          {
            "stage": "الأسئلة",
            "title": "بناء بنك الأسئلة",
            "body": "يتم إعداد أسئلة مرتبطة بكل فصل، مع شروحات للإجابات، بهدف قياس الفهم وتعزيز الاستعداد للاختبارات."
          },
          {
            "stage": "المراجعة",
            "title": "المراجعة العلمية",
            "body": "يراجع المحتوى مختصون للتأكد من دقته، وتوافقه مع أحدث المعايير، وخلوه من الأخطاء العلمية واللغوية."
          },
          {
            "stage": "النشر",
            "title": "النشر داخل المنصة",
            "body": "بعد اعتماد المحتوى، يتم تحويله إلى تجربة رقمية تفاعلية تتضمن القراءة، والملاحظات، والتظليل، والبحث، وأدوات التعلم الذكية."
          },
          {
            "stage": "التحديث",
            "title": "التحديث المستمر",
            "body": "يتم تحديث الكتب والمناهج بشكل دوري لمواكبة أي تغييرات في متطلبات الشهادات المهنية، مع توفير أحدث الإصدارات للمستخدمين."
          }
        ]
      },
      "expertise": {
        "pill": "الخبرة و الموثوقية",
        "title": "خبرة راسخة... وتجربة تعليمية متطورة",
        "lead": "تم تطوير Learning-Go Education اعتمادًا على الخبرة العملية لمنصة Learning-Go في تصميم الحلول التعليمية الرقمية، لتقديم تجربة متخصصة في الشهادات المهنية تجمع بين المحتوى الاحترافي، والتقنيات التعليمية الحديثة، وأدوات التعلم والتدريب في منصة واحدة.",
        "claims": {
          "experience": {
            "title": "خبرة ممتدة",
            "body": "لم تُبنَ Learning-Go Education من الصفر، بل انطلقت اعتمادًا على الخبرة العملية التي اكتسبتها منصة Learning-Go في تصميم وتقديم التجارب التعليمية الرقمية."
          },
          "practice": {
            "title": "محتوى مبني على الممارسة",
            "body": "تم تطوير المناهج والكتب التعليمية اعتمادًا على احتياجات المتعلمين والمدربين والمعاهد، مع التركيز على تبسيط المفاهيم وربطها بالتطبيق العملي."
          },
          "proven": {
            "title": "منصة أثبتت نجاحها",
            "body": "تعتمد Learning-Go Education على بنية تقنية وتجربة استخدام تم تطويرها واختبارها عبر سنوات، مما يوفر تجربة تعليمية مستقرة وسهلة الاستخدام."
          },
          "evolving": {
            "title": "تطوير مستمر",
            "body": "يتم تحديث المحتوى والمنصة بشكل دوري لمواكبة متطلبات الشهادات المهنية وأفضل ممارسات التعلم الرقمي."
          }
        }
      }
    },
    "BookExpandSection": "فتح القسم {{number}}",
    "BookCollapseSection": "طي القسم {{number}}",
    "LearningSectionMoveUp": "نقل القسم إلى الأعلى",
    "LearningSectionMoveDown": "نقل القسم إلى الأسفل",
    "InteractiveBookReorderError": "تعذر حفظ ترتيب الأقسام. أعد تحميل الكتاب وحاول مرة أخرى.",
    "EditorUploadCustomIcon": "رفع أيقونة مخصصة",
    "EditorUploadedIcon": "الأيقونة المرفوعة",
    "EditorCustomIconHint": "PNG أو JPG أو WebP أو GIF. تُستخدم الصورة بدلاً من نقطة التعداد الحالية أو تُدرج كأيقونة داخل النص، مع الاحتفاظ بألوانها.",
    "EditorDefaultBullet": "النقطة الافتراضية",
    "InteractiveBookOptionalFilters": "يمكنك تصفية الوحدات حسب الشهادة والدورة، أو البحث مباشرة في جميع الوحدات بالاسم أو الترتيب. كلا المرشحين اختياري.",
    "InteractiveBookCertificateFilter": "الشهادة (اختياري)",
    "InteractiveBookCourseFilter": "الدورة (اختياري)",
    "InteractiveBookAllCertificates": "جميع الشهادات",
    "InteractiveBookAllCourses": "جميع الدورات",
    "InteractiveBookLinkedUnit": "الوحدة المرتبطة بهذا الفصل",
    "InteractiveBookLinkedTopic": "الموضوع المرتبط بهذا القسم",
    "InteractiveBookSearchNameRank": "ابحث بالاسم أو الترتيب",
    "InteractiveBookLinkParentFirst": "اختر وحدة للفصل الذي يتبعه هذا القسم واحفظها أولاً، ثم اختر موضوع القسم.",
    "InteractiveBookUnitRequired": "اختر وحدة متاحة لربطها بهذا الفصل.",
    "InteractiveBookTopicRequired": "اختر موضوعاً من الوحدة المرتبطة بهذا الفصل.",
    "InteractiveBookUnitChangeConfirmation": "سيؤدي تغيير وحدة الفصل إلى إلغاء ارتباط أقسامه بالموضوعات الحالية. سيبقى محتوى الأقسام محفوظاً، وستحتاج إلى اختيار موضوعات من الوحدة الجديدة. هل تريد المتابعة؟",
    "InteractiveBookLinkLoadError": "تعذر تحميل الخيارات المتاحة. غيّر عبارة البحث للمحاولة مرة أخرى.",
    "BookLinkedCourses": "المقررات المرتبطة",
    "BookUnlinkedUnit": "وحدة غير مرتبطة",
    "BookNodeEnabled": "مفعّل في الكتاب",
    "BookNodeDisabled": "معطّل",
    "BookSerialNumber": "الرقم التسلسلي",
    "BookDoneReading": "انتهيت من القراءة",
    "BookMarkUnread": "تحديد كغير مقروء",
    "BookManualProgressError": "تعذر حفظ تقدم القراءة. حاول مرة أخرى.",
    "BookLinkHierarchy": "تسلسل الارتباطات",
    "BookSectionType": "نوع القسم",
    "BookSectionContent": "محتوى",
    "BookSectionExam": "اختبار",
    "BookSectionExamClearsContent": "تعرض أقسام الاختبار اختبارات الموضوع المرتبط فقط. سيؤدي الحفظ إلى إزالة محتوى هذا القسم بالعربية والإنكليزية.",
    "BookSharedContentHint": "يمكن ربط هذا الكتاب بعدة مقررات. تعديلات المحتوى تظهر في جميع المقررات المرتبطة، مع فصل الروابط والتقدم لكل مقرر.",
    "BookLinkCourse": "ربط مقرر",
    "BookAssignmentActive": "استخدامه كتاباً للمقرر (ألغِ التحديد لفك الربط)",
    "BookReplacePrimary": "استبدال الكتاب الحالي لهذا المقرر",
    "BookMappingHint": "اربط جميع الفصول والأقسام قبل التفعيل. فك الربط يحتفظ بسجلات الطالب.",
    "BookCourseLoadError": "تعذر تحميل المقررات المرتبطة.",
    "BookCourseSaveError": "تعذر حفظ روابط المقرر. تحقق من الوحدات والمواضيع المحددة.",
    "BookCourseInvalid": "روابط المقرر غير صالحة.",
    "BookMappingsIncomplete": "اربط جميع الفصول والأقسام قبل تفعيل الكتاب.",
    "BookCourseAlreadyLinked": "هذا المقرر مرتبط بكتاب. اختر استبدال الكتاب الحالي لتغييره.",
    "BookImport": "استيراد كتاب تفاعلي",
    "BookExport": "تصدير",
    "BookExportTitle": "تصدير الكتاب التفاعلي",
    "BookExportIncludeMedia": "تضمين ملفات الوسائط",
    "BookExportMediaHint": "يضمّن الصور والملفات الصوتية المخزنة على الخادم داخل ملف التصدير. تبقى الوسائط الخارجية مرتبطة بالرابط، وقد يصبح حجم الملف أكبر بكثير.",
    "BookImportInvalidFile": "اختر ملف JSON صالحاً مُصدّراً لكتاب تفاعلي (بحد أقصى 150 ميجابايت).",
    "BookImportError": "تعذر استيراد الكتاب التفاعلي.",
    "BookExportError": "تعذر تصدير الكتاب التفاعلي.",
    "BookExportMediaError": "تعذر تضمين وسائط الكتاب. تحقق من توفر الملفات المخزنة والتزامها بحدود الحجم.",
    "BookImportMediaError": "تعذر تخزين الوسائط المضمّنة على الخادم.",
    "BookDuplicate": "نسخ الكتاب التفاعلي",
    "BookCopySuffix": "نسخة",
    "BookDuplicateHint": "ينشئ نسخة مستقلة كمسودة بالمحتوى المحفوظ، دون نسخ سجلات الطلاب أو روابط المقررات.",
    "BookDuplicateError": "تعذر نسخ الكتاب. حاول مجدداً.",
    "BookNotAvailable": "لا يتوفر كتاب منشور لهذا المقرر ضمن اشتراكك.",
    "BookChooseCourse": "افتح الكتاب من المقرر الذي تريد دراسته.",
    "BookOpenFromCourse": "افتح الكتاب من مقررك.",
    "BookBackToCourse": "العودة إلى المقرر",
    "BookShowPages": "عرض صفحات الكتاب",
    "BookPagesTitle": "صفحات الكتاب",
    "BookPagesAll": "الكل",
    "BookPagesSaved": "محفوظة",
    "BookPagesFilters": "تصفية صفحات الكتاب",
    "BookPagesLoading": "جارٍ تحميل الصفحات…",
    "BookPagesEmpty": "لا توجد صفحات مطابقة لهذا الفلتر.",
    "BookOpenPage": "فتح الصفحة {{number}}: {{title}}",
    "BookProgressRetry": "تعذر حفظ تقدم القراءة. أعد المحاولة ثم اقرأ هذا القسم مجدداً.",
    "BookChapterProgress": "تقدم الفصل: {{percent}}٪",
    "BookCourseProgress": "تقدم المقرر: {{percent}}٪",
    "BookReadingProgressHint": "اضغط انتهيت من القراءة بعد إكمال القسم. يمكنك تحديده كغير مقروء لاحقاً.",
    "BookAdditionalMaterials": "الفيديوهات والتدريبات حسب الموضوع",
    "BookReadingNotStarted": "ابدأ قراءة القسم قبل إكماله.",
    "BookCopyReuse": "إعادة استخدام الكتاب نفسه",
    "BookCopyIndependent": "إنشاء نسخة مستقلة من الكتاب"
  }
}
